// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-21T22:01:04.709Z
// Property: Parc Lofts (ID: 6767906449166442)
// Collections: 28 amenities, 3 floorplans (live), 25 photos, 50 POIs, 3 reviews, 6 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166442",
  "property_external_id": "jzfxlj4",
  "property_zillow_url": "https://www.zillow.com/apartments/tolleson-az/parc-lofts/CkBBKs/",
  "property_apartments_url": "https://www.apartments.com/parc-lofts-tolleson-az/jzfxlj4/",
  "property_google_business_url": "https://www.google.com/maps/place/Parc+Lofts/data=!4m2!3m1!1s0x0:0x8554a4ae6c293e1b?sa=X&ved=2ahUKEwjVrt-w46eSAxWyd_UHHW5rMmEQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "40261522739",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "905PLO",
  "property_status": null,
  "property_slug": "parc-lofts",
  "property_name": "Parc Lofts",
  "property_website_url": "https://www.liveatparclofts.com/",
  "property_domain": "https://www.liveatparclofts.com/",
  "property_address": "8727 West McDowell Road",
  "property_full_address": "8727 W McDowell Rd, Tolleson, AZ 85353",
  "property_address_1": "8727 W McDowell Rd",
  "property_address_2": null,
  "property_address_city": "Tolleson",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "85353",
  "property_address_country": "US",
  "property_address_county": "Maricopa County",
  "property_neighborhood_address": "Maryvale",
  "property_address_latitude": "33.4642511",
  "property_address_longitude": "-112.2506909",
  "property_email": null,
  "property_phone": "(888) 900-8133",
  "property_call_tracking_phone": "877-409-2829",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Parc Lofts in Tolleson, AZ, your ideal living space awaits. Choose from spacious one, two, or three-bedroom floor plans featuring sleek quartz countertops, stainless steel appliances, and private balconies. Indulge in top-notch amenities like a hot tub, outdoor fire pit, and pet-friendly spaces. Secure your dream home today!",
  "property_long_description": "Welcome to Parc Lofts, the premier apartment community nestled in the heart of Tolleson, AZ! Offering a diverse selection of spacious floor plans, including one, two, and three-bedroom options, Parc Lofts combines modern comfort with unparalleled amenities to create the perfect living environment. \n\nExplore our beautifully designed apartments featuring open layouts, sleek quartz countertops, and stainless steel appliances, complemented by wood flooring and ceiling fans throughout. Enjoy the convenience of in-unit washers and dryers, walk-in closets, and private balconies or patios to unwind and soak in the views. \n\nAt Parc Lofts, we believe in enriching your lifestyle beyond the four walls of your apartment. Our community boasts a luxurious clubhouse, a 24-hour fitness center, and an inviting outdoor space complete with BBQ & picnic areas, an outdoor fire pit, and TVs for your entertainment. Stay active with cornhole boards and our pet park, or unwind with your furry friends at our pet washing station! \n\nSafety and convenience are paramount, with our gated community, covered parking, valet trash service, EV charging stations, and 24-hour emergency maintenance ensuring your peace of mind. \n\nDiscover why living at Parc Lofts means embracing a vibrant and fulfilling lifestyle. Find your new home today—browse our availability or schedule a tour to experience our exceptional community firsthand! Your ideal apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f6b9a-f8df-747c-bacc-cb79f337df1a.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of a resort-style pool and hot tub area with palm trees and lounge chairs.",
    "public_id": "019f6b9a-f8df-747c-bacc-cb79f337df1a",
    "storage_key": "property/6767906449166442/019f6b9a-f8df-747c-bacc-cb79f337df1a.webp",
    "width": 1920,
    "height": 1440
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166442/019ffc3a-a9a7-718a-8637-439ef46db719.m4v",
  "property_featured_video_media": {
    "public_id": "019ffc3a-a9a7-718a-8637-439ef46db719",
    "storage_key": "property/6767906449166442/019ffc3a-a9a7-718a-8637-439ef46db719.m4v",
    "thumbnail_key": "property/6767906449166442/019ffc3a-a9a7-718a-8637-439ef46db719_thumb.webp",
    "size_bytes": 21696178,
    "classification": "Community",
    "title": "Modern Apartment Community Amenities and Interiors",
    "description": "Explore the amenities of this vibrant apartment community, including a fitness center, outdoor gathering spaces, and stylish interior living areas."
  },
  "property_total_units": "258",
  "property_year_built": "2023",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.51162790697676",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Dogs and cats allowed (breed and weight restrictions may apply). Maximum of 2 pets per unit.",
  "property_pet_policy_description": "Dogs and cats allowed (breed and weight restrictions may apply). Maximum of 2 pets per unit. One-time pet fee: $300 per pet. Monthly pet rent: $35 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://parclofts.goprisma.com/auth/login",
  "property_apply_now_url": "https://www.myrentalapplication.com/index/amcparclofts",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02cc-57fa-7357-9524-15811ba38899.webp",
  "property_primary_logo_media": {
    "alt_text": "Parc Lofts logo",
    "public_id": "019d02cc-57fa-7357-9524-15811ba38899",
    "storage_key": "property/6767906449166442/019d02cc-57fa-7357-9524-15811ba38899.webp",
    "width": 300,
    "height": 95
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02cc-452b-73ee-b989-6eee70133827.webp",
  "property_secondary_logo_media": {
    "alt_text": "Apartment Management Consultants logo.",
    "public_id": "019d02cc-452b-73ee-b989-6eee70133827",
    "storage_key": "property/6767906449166442/019d02cc-452b-73ee-b989-6eee70133827.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02cc-6f5b-729d-b7e8-15914f2aaac1.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Parc Lofts logo",
    "public_id": "019d02cc-6f5b-729d-b7e8-15914f2aaac1",
    "storage_key": "property/6767906449166442/019d02cc-6f5b-729d-b7e8-15914f2aaac1.webp",
    "width": 300,
    "height": 95
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02cc-57fa-7357-9524-15811ba38899.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Parc Lofts logo",
    "public_id": "019d02cc-57fa-7357-9524-15811ba38899",
    "storage_key": "property/6767906449166442/019d02cc-57fa-7357-9524-15811ba38899.webp",
    "width": 300,
    "height": 95
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "741 - 1310",
  "property_sqft_min": "741",
  "property_sqft_max": "1310",
  "property_price_range": "$1461 - $1949",
  "property_price_min": "1461",
  "property_price_max": "1949",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/parcloftsapts",
  "property_instagram_url": "https://www.instagram.com/parctolleson/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ5ZrkbvA_K4cRGz4pbK6kVIU",
  "property_youtube_url": null,
  "property_yelp_url": "https://m.yelp.com/search?cflt=apartments&find_loc=Tolleson%2C+AZ",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Parc Lofts",
  "property_home_romance_title": "Embrace Life in Your Ideal Apartment Community Today  ",
  "property_home_amenities_blurb": "Nestled in sunny Tolleson, AZ, Parc Lofts offers a vibrant blend of modern living and community charm. Choose from spacious one, two, or three-bedroom apartments featuring sleek quartz countertops and private patios. Enjoy our clubhouse, hot tub, outdoor fire pit, and pet-friendly amenities—all designed for your ultimate comfort and convenience.",
  "property_home_floorplans_blurb": "At Parc Lofts in Tolleson, AZ, your ideal living space awaits! With spacious one, two, and three-bedroom floor plans, each home is designed for comfort and style. Browse our available apartment homes to uncover the perfect floor plan that suits your lifestyle. Embrace modern living today!",
  "property_home_gallery_blurb": "At Parc Lofts in Tolleson, AZ, vibrant living meets modern luxury. Choose from spacious one, two, or three-bedroom floor plans, complete with sleek quartz countertops and private balconies. Enjoy our clubhouse, fitness center, and outdoor amenities, all within a gated community designed for your comfort and convenience. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At Parc Lofts in Tolleson, AZ, your lifestyle is enhanced by nearby gems like the exhilarating Camelback Ranch, vibrant Friendship Park, and the engaging Mattel Adventure Park. With spacious one, two, and three-bedroom floor plans, enjoy cozy living paired with excitement just around the corner. See what's nearby!",
  "property_home_reviews_blurb": "At Parc Lofts in Tolleson, AZ, residents rave about the welcoming atmosphere, noting it as “a perfect blend of comfort and style.” Experience vibrant community living where memories are made. Interested in finding out more? See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in the heart of Tolleson, Parc Lofts offers more than just stylish living. Enjoy easy access to stunning parks like Friendship Park and Glendale Heroes Regional Park, or discover recreational fun at EōS Fitness. Whether you're catching a game at State Farm Stadium or teeing off at the Grand Canyon University Championship Golf Course, there's something for everyone. Curious about the neighborhood? See what's around our community and explore local favorites and nearby points of interest!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Parc Lofts in Tolleson, AZ, each apartment is a sanctuary with open floor plans, stainless steel appliances, and private balconies. Enrich your lifestyle with our clubhouse, outdoor fire pit, and pet park. Embrace comfort, convenience, and community — there’s truly something for everyone here!",
  "property_applynow_blurb": "At Parc Lofts in Tolleson, AZ, stylish living awaits! Choose from one, two, or three-bedroom floor plans designed for comfort and convenience. Enjoy luxe amenities like a hot tub, pet park, and 24-hour fitness center. Your perfect home is just a click away—lease online today!",
  "property_contactus_blurb": "At Parc Lofts in Tolleson, AZ, your perfect home awaits with a variety of spacious floor plans, from cozy one-bedroom retreats to expansive three-bedroom residences. Every corner is designed for comfort and style. Have questions? Contact our leasing team today to find your ideal living space!",
  "property_faqs_blurb": "At Parc Lofts in Tolleson, AZ, your dream living space awaits. From cozy one-bedroom nooks to spacious three-bedroom layouts, each floor plan offers a unique blend of comfort and style. Curious about our community? Visit our FAQs page for insights that make your apartment search effortless.",
  "property_floorplans_blurb": "At Parc Lofts in Tolleson, AZ, our versatile floor plans cater to your lifestyle. Whether you seek a cozy one-bedroom retreat or a spacious three-bedroom haven, each layout is designed with modern living in mind. Browse our available apartment homes and find the perfect space to call your own.",
  "property_gallery_blurb": "At Parc Lofts in Tolleson, AZ, envision your ideal living space with our stunning one, two, and three-bedroom floor plans. Indulge in luxury amenities, from a vibrant clubhouse and relaxing hot tub to a pet-friendly park and state-of-the-art fitness center. Picture yourself living here and elevate your lifestyle!",
  "property_interactivemap_blurb": "At Parc Lofts in Tolleson, AZ, choose from stylish one, two, or three-bedroom apartments designed for modern living. Enjoy exceptional amenities like a pet-friendly park, 24-hour fitness center, and inviting outdoor spaces. Use our interactive community map to find your perfect home and experience upscale comfort today!",
  "property_pets_blurb": "At Parc Lofts in Tolleson, AZ, your pets are part of the family! Enjoy spacious living with room for up to two furry companions. With a one-time fee of $300 and a monthly pet rent of $35 each, make your apartment feel like home for every tail-wagging and purring friend.",
  "property_referafriend_blurb": "At Parc Lofts in Tolleson, AZ, we believe that great friends make great neighbors. Our vibrant community offers thoughtfully designed one, two, and three-bedroom floor plans, perfect for sharing life’s moments. Invite a friend to join you in this dynamic space—refer them today and enhance your living experience!",
  "property_residentaccess_blurb": "Welcome to Parc Lofts in Tolleson, AZ, your gateway to convenient living. Whether you prefer a cozy one-bedroom or a spacious three-bedroom layout, our floor plans cater to your lifestyle. Log in to your resident portal for easy rent payments, maintenance requests, and essential community updates!",
  "property_reviews_blurb": "At Parc Lofts in Tolleson, AZ, our residents rave about the vibrant community atmosphere, stating, “Living here feels like home!” Dive into our reviews and see why so many cherish the blend of comfort and convenience we offer. Check out what makes Parc Lofts a beloved choice!",
  "property_created_at": "1759782572249",
  "property_scheduletour_blurb": "At Parc Lofts in Tolleson, AZ, choose from thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Experience the perfect blend of comfort and style—don’t just take our word for it; hear firsthand from our satisfied residents. Schedule a tour today and feel at home!",
  "property_thankyou_blurb": "Thank you for reaching out! At Parc Lofts in Tolleson, AZ, we offer a variety of stylish floor plans, including one, two, and three-bedroom options to fit your lifestyle. A team member will connect with you soon to help you find your perfect home!",
  "property_virtualtours_blurb": "At Parc Lofts in Tolleson, AZ, experience the perfect blend of comfort and style with our thoughtfully designed one, two, and three-bedroom floor plans. Immerse yourself in our vibrant community—take a virtual tour today and envision your new life in an apartment that feels like home.",
  "property_copyright": "2025 All Rights Reserved. Parc Lofts",
  "property_seo_title_home": "Parc Lofts | Tolleson Apartments For Rent",
  "property_seo_description_home": "Located in Tolleson, we offer 1, 2, & 3-bedroom pet-friendly apartments for rent. Come home to our luxury apartments!",
  "property_seo_title_floorplans": "Floor Plans | 1, 2, & 3 Bedroom Apartments Tolleson, AZ",
  "property_seo_description_floorplans": "Parc Lofts offers 1, 2, & 3-bedroom apartments with modern comfort in Tolleson, AZ. Browse our apartments for rent now!",
  "property_seo_title_amenities": "Amenities | Pet-Friendly Apartments in Tolleson, AZ",
  "property_seo_description_amenities": "Located in Tolleson, Parc Lofts offers 1, 2, & 3-bedroom apartments with luxury interiors & resort-style amenities.",
  "property_seo_title_gallery": "Gallery | Apartments For Rent in Tolleson, AZ",
  "property_seo_description_gallery": "View your pet-friendly apartments for rent in Tolleson, AZ, through our photos. Explore apartment interiors, amenities, & more. Take a look at the photos now!",
  "property_seo_title_virtualtours": "Virtual Tour | Tolleson Apartments For Rent",
  "property_seo_description_virtualtours": "Discover your new home at Parc Lofts! Take a virtual tour of our floor plans, amenities, & more. Start your tour now in Tolleson, AZ!",
  "property_seo_title_interactivemap": "Interactive Map | Apartments in Tolleson Near Westgate",
  "property_seo_description_interactivemap": "View available units at Parc Lofts in Tolleson, AZ with our interactive apartment map. Find your perfect home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tolleson Near Westgate",
  "property_seo_description_neighborhood": "Parc Lofts is in Tolleson, AZ, near Westgate, the Tanger Outlets, & Banner Hospital. Come in for a tour of our apartments!",
  "property_seo_title_contact": "Contact Us | Tolleson Apartments for Rent",
  "property_seo_description_contact": "Have questions about our Tolleson apartments for rent or want to schedule a tour? Our amazing leasing team is ready to help! Contact us today!",
  "property_seo_title_faqs": "FAQs | Apartments in Tolleson, AZ",
  "property_seo_description_faqs": "Find answers to your questions about Parc Lofts in Tolleson, AZ! Explore our exceptional amenities, flexible floor plans, and pet-friendly lifestyle.",
  "property_seo_title_reviews": "Reviews | Apartments in Tolleson, AZ",
  "property_seo_description_reviews": "Explore feedback from residents of Parc Lofts! Learn firsthand experiences and gain insights into our vibrant apartment community in Tolleson, AZ.",
  "property_seo_title_applynow": "Apply Now | 1, 2, & 3 Bedroom Tolleson, AZ Apartments",
  "property_seo_description_applynow": "Apply online for our 1, 2, & 3-bedroom apartments for rent in Tolleson, AZ. Complete the application today!",
  "property_seo_title_residentaccess": "Resident Access | Tolleson Apartments for Rent",
  "property_seo_description_residentaccess": "With convenient 24/7 access, the resident portal makes it easy for you to request maintenance service and pay your rent online. Log in to get started.",
  "property_seo_title_referafriend": "Refer a Friend | Apartments in Tolleson, AZ",
  "property_seo_description_referafriend": "Refer a friend to Parc Lofts and both of you can enjoy fantastic perks. Spread the word!",
  "property_seo_title_scheduletour": "Schedule a Tour | Apartments in Tolleson, AZ",
  "property_seo_description_scheduletour": "Ready to explore Parc Lofts firsthand? Book a tour and uncover our amenities and 1, 2, & 3-bedroom apartments in Tolleson, AZ!",
  "property_seo_title_privacy": "Privacy Policy | Parc Lofts",
  "property_seo_description_privacy": "Safeguarding your personal data is our priority at Parc Lofts in Tolleson, AZ. Learn how we protect your privacy in our comprehensive policy.",
  "property_seo_title_accessibility": "Website Accessibility | Parc Lofts",
  "property_seo_description_accessibility": "Experience inclusive living at Parc Lofts in Tolleson, AZ. Our commitment to accessibility ensures everyone feels at home. Join our vibrant community today!",
  "property_seo_title_sitemap": "Sitemap | Parc Lofts",
  "property_seo_description_sitemap": "Uncover the charm of Parc Lofts in Tolleson, AZ. Navigate our sitemap for easy access to amenities, floor plans, and community events that await you!",
  "property_seo_title_thankyou": "Thank You | Apartments for Rent in Tolleson, AZ",
  "property_seo_description_thankyou": "Thank you for your interest in Parc Lofts. We will process your request and get back to you shortly!",
  "property_seo_title_pets": "Pets | Apartments in Tolleson, AZ",
  "property_seo_description_pets": "At Parc Lofts in Tolleson, AZ, your pets are part of the family! Enjoy spacious living with room for up to two furry companions.",
  "property_updated_at": "1786643134908",
  "amenities": [
    {
      "id": "custom_ff98e8bc-822a-45df-bed6-8ed78239b34d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_5a381518-2296-4fe9-b0eb-420b813c325a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Hot Tub",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a1f9af8f-e394-465b-984c-2da54bff8898",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Cornhole Boards",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_cb7e56cb-11e6-444f-85fb-18584bccb058",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "BBQ & Picnic Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_96b4a10b-9cd7-4c4a-9339-c7de2aa16982",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Washing Station",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_9d877480-bb1d-4298-8eb2-c0746f8ef904",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_5b67b9ec-a453-46d2-ba4f-5965412ece2f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_46c89ece-9275-48ff-b2b6-21fe2d5a0046",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_efabfcd1-a2fe-4df9-8ccc-d9e93406a747",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Fire Pit",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_6fd2b2e2-322d-461d-9c24-35578724e6e4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "EV Charging Stations",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_215b8b45-152d-488a-b465-f040b846f08a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Covered Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_d2efe7d4-ad17-4e8c-bf56-c20e2645b128",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_066470cd-9790-484a-8d27-4e0d42904c7d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Valet Trash Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_0131a735-545b-43e0-9a4d-d1524ee7ae5c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor TVs",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_86502612-6899-495c-8400-7070892697c8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Open Floorplans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_cf3b1b2b-957d-4dd6-af8a-ee8f27fb9536",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_008e5b1f-b453-4ccb-910b-cd11f70c61ce",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_65a312bc-0aaa-4977-a164-cb1480e3e767",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Wood Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_70ce019a-686c-40a6-9ec3-6b138ca0b371",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a5499035-2da0-4d48-9268-e8bf9be2c81f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Walk In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_3bacd3d9-a55b-4f15-b3d6-5c58d62152de",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryer in Unit",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_b33f733f-bed1-49a4-acc0-24738138e817",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Private Balconies/Patios",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_59681f7f-a8a3-4b55-a236-a37077e32c73",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Central Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_1125f056-73ed-4235-901c-4d83436047a7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_438de3a6-d0b1-4f92-b599-202916526cab",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f208bd34-c626-4166-8af0-8b5d1f662f37",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Sleek Quartz Countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_1c2bc0ab-c063-4756-8ab9-7ec58d6f659d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_6788e617-b671-4767-b7c1-9a708ef23f4b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Peninsulas*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_0dbfb19c-cfa9-4155-8ff6-f6ec89d5e0da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/01a0110e-4c3e-76ff-97da-d4eb2af821e9.webp",
      "image_media": {
        "alt_text": "Parc Lofts Luxury Apartments monument sign",
        "public_id": "01a0110e-4c3e-76ff-97da-d4eb2af821e9",
        "storage_key": "property/6767906449166442/01a0110e-4c3e-76ff-97da-d4eb2af821e9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Parc Lofts Luxury Apartments, a premier residential community offering modern living.",
      "link": "",
      "alt_text": "Parc Lofts Luxury Apartments monument sign",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_29093ee7-9d1f-41d4-a94a-0a23eab8cf5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/01a0110e-4b9d-7607-b8a3-3861e725adff.webp",
      "image_media": {
        "alt_text": "Exterior of the apartment building with modern architecture and landscaping at Parc Lofts in Tolleson, AZ.",
        "public_id": "01a0110e-4b9d-7607-b8a3-3861e725adff",
        "storage_key": "property/6767906449166442/01a0110e-4b9d-7607-b8a3-3861e725adff.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern exterior of the apartment building featuring clean lines, textured walls, and manicured landscaping. The entrance is inviting with a green neon sign.",
      "link": "",
      "alt_text": "Exterior of the apartment building with modern architecture and landscaping at Parc Lofts in Tolleson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_92f6b6f3-1d79-4f33-a648-dd3fce5a591d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/01a0110e-378d-71a0-bc2e-81d0ebfcf51d.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building entrance with parking lot and palm trees at Parc Lofts in Tolleson, AZ.",
        "public_id": "01a0110e-378d-71a0-bc2e-81d0ebfcf51d",
        "storage_key": "property/6767906449166442/01a0110e-378d-71a0-bc2e-81d0ebfcf51d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring a welcoming entrance, ample parking, and lush landscaping. Enjoy a resort-style living experience.",
      "link": "",
      "alt_text": "Exterior view of apartment building entrance with parking lot and palm trees at Parc Lofts in Tolleson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7549e257-cc6f-48e3-8e36-3ba199bb6634",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/01a0110e-6f3e-7341-aac7-4240cd19f034.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with stucco facade and balconies at Parc Lofts in Tolleson, AZ.",
        "public_id": "01a0110e-6f3e-7341-aac7-4240cd19f034",
        "storage_key": "property/6767906449166442/01a0110e-6f3e-7341-aac7-4240cd19f034.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stunning exterior of the apartment complex, showcasing modern architecture and well-maintained grounds.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with stucco facade and balconies at Parc Lofts in Tolleson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c3103797-7b53-4b3f-89f0-a06ff542d2df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/01a0110e-58a0-76ff-9c15-8b17928163ae.webp",
      "image_media": {
        "alt_text": "Outdoor community area with a swimming pool, grilling stations, and cornhole game.",
        "public_id": "01a0110e-58a0-76ff-9c15-8b17928163ae",
        "storage_key": "property/6767906449166442/01a0110e-58a0-76ff-9c15-8b17928163ae.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the vibrant community amenities, including a sparkling swimming pool, convenient grilling stations, and fun outdoor games for recreation.",
      "link": "",
      "alt_text": "Outdoor community area with a swimming pool, grilling stations, and cornhole game.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ae701250-bf55-4b08-9717-333e9515c68e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/01a0110d-d481-7058-82e4-d1adece5082d.webp",
      "image_media": {
        "alt_text": "Lounge area with wood-paneled walls, comfortable seating, and a TV displaying a tropical scene.",
        "public_id": "01a0110d-d481-7058-82e4-d1adece5082d",
        "storage_key": "property/6767906449166442/01a0110d-d481-7058-82e4-d1adece5082d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge area, featuring rustic wood accents, plush seating, and a large screen TV.",
      "link": "",
      "alt_text": "Lounge area with wood-paneled walls, comfortable seating, and a TV displaying a tropical scene.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_07e3c116-b137-445e-be42-284e8e7b3450",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/01a0110e-171a-70b0-9f37-4bb9d355c175.webp",
      "image_media": {
        "alt_text": "Community lounge with pool table, dining table, and TV at Parc Lofts in Tolleson, AZ.",
        "public_id": "01a0110e-171a-70b0-9f37-4bb9d355c175",
        "storage_key": "property/6767906449166442/01a0110e-171a-70b0-9f37-4bb9d355c175.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in the community lounge, featuring a pool table, large dining area, and entertainment space with TVs.",
      "link": "",
      "alt_text": "Community lounge with pool table, dining table, and TV at Parc Lofts in Tolleson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1b560b79-954b-41f7-b882-197ccb16b864",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/01a0110d-c53e-71b8-905d-faadda689ff7.webp",
      "image_media": {
        "alt_text": "Community lounge with large wooden table, chairs, TV, and modern chandelier. Large windows overlook pool area.",
        "public_id": "01a0110d-c53e-71b8-905d-faadda689ff7",
        "storage_key": "property/6767906449166442/01a0110d-c53e-71b8-905d-faadda689ff7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in our stylish community lounge, perfect for meetings or relaxation. Enjoy the view of the pool and outdoor amenities.",
      "link": "",
      "alt_text": "Community lounge with large wooden table, chairs, TV, and modern chandelier. Large windows overlook pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fac026bc-d234-41e6-96f9-1f7767025581",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/01a0110d-fee5-722d-a0bc-773d18ebefee.webp",
      "image_media": {
        "alt_text": "Modern gym with cardio machines, weight machines, benches, and kettlebells.",
        "public_id": "01a0110d-fee5-722d-a0bc-773d18ebefee",
        "storage_key": "property/6767906449166442/01a0110d-fee5-722d-a0bc-773d18ebefee.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio and strength training equipment, perfect for your workout routine.",
      "link": "",
      "alt_text": "Modern gym with cardio machines, weight machines, benches, and kettlebells.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2c1dbde2-87f8-405b-a268-25a3a583ad4a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/01a0110e-097f-7522-80c5-577f0939f9a8.webp",
      "image_media": {
        "alt_text": "Modern apartment fitness center with cardio machines, free weights, yoga mats, and view of the pool at Parc Lofts in Tolleson, AZ.",
        "public_id": "01a0110e-097f-7522-80c5-577f0939f9a8",
        "storage_key": "property/6767906449166442/01a0110e-097f-7522-80c5-577f0939f9a8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, weight machines, free weights, and yoga mats. Enjoy a workout with a view of the resort-style pool.",
      "link": "",
      "alt_text": "Modern apartment fitness center with cardio machines, free weights, yoga mats, and view of the pool at Parc Lofts in Tolleson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2ada044e-50c9-49f2-876d-0518003a1084",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/01a0110d-bb3d-70bd-9f45-bc05ff5444ca.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with a built-in grill and a long bar with stools at Parc Lofts in Tolleson, AZ.",
        "public_id": "01a0110d-bb3d-70bd-9f45-bc05ff5444ca",
        "storage_key": "property/6767906449166442/01a0110d-bb3d-70bd-9f45-bc05ff5444ca.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining with our community's BBQ grill and bar area.",
      "link": "",
      "alt_text": "Outdoor grilling area with a built-in grill and a long bar with stools at Parc Lofts in Tolleson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2b825328-6221-4aea-879f-036230943ae7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/01a0110e-7775-70ff-84d4-0d34eadc1155.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with covered seating, chaise lounges, and a fireplace under a palm tree.",
        "public_id": "01a0110e-7775-70ff-84d4-0d34eadc1155",
        "storage_key": "property/6767906449166442/01a0110e-7775-70ff-84d4-0d34eadc1155.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor lounge area, featuring comfortable seating, shaded pergolas, and a cozy fireplace. Perfect for enjoying the beautiful weather.",
      "link": "",
      "alt_text": "Outdoor lounge area with covered seating, chaise lounges, and a fireplace under a palm tree.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_28058833-3a1c-47d6-9a5c-2034f5d92ff4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/01a0110d-fc3f-775f-a8e3-6ede525487d1.webp",
      "image_media": {
        "alt_text": "Modern outdoor seating area with a fire pit, lounge chairs and pool.",
        "public_id": "01a0110d-fc3f-775f-a8e3-6ede525487d1",
        "storage_key": "property/6767906449166442/01a0110d-fc3f-775f-a8e3-6ede525487d1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling pool or gather around the contemporary fire pit in this inviting outdoor lounge area.",
      "link": "",
      "alt_text": "Modern outdoor seating area with a fire pit, lounge chairs and pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7d9381a3-b33b-4b48-9fea-78d8813dc2de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/01a0110e-72cd-744c-9281-b9342492c22a.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and palm trees at Parc Lofts in Tolleson, AZ.",
        "public_id": "01a0110e-72cd-744c-9281-b9342492c22a",
        "storage_key": "property/6767906449166442/01a0110e-72cd-744c-9281-b9342492c22a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, surrounded by lush greenery and comfortable lounge chairs.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and palm trees at Parc Lofts in Tolleson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7d3f9b90-9fce-4372-8a80-338ca48f7c2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/01a0110e-86f0-748c-87a5-7c0a4adfabed.webp",
      "image_media": {
        "alt_text": "Swimming pool and hot tub area with palm trees and lounge chairs.",
        "public_id": "01a0110e-86f0-748c-87a5-7c0a4adfabed",
        "storage_key": "property/6767906449166442/01a0110e-86f0-748c-87a5-7c0a4adfabed.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool or relax in the soothing hot tub, surrounded by lush palm trees and comfortable lounge chairs.",
      "link": "",
      "alt_text": "Swimming pool and hot tub area with palm trees and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3c980842-15e6-47c7-8b8f-c37004f14fce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/01a0110e-044f-718d-802b-6d8dc1b32009.webp",
      "image_media": {
        "alt_text": "Outdoor barbecue area with grills, seating, and cornhole boards at Parc Lofts in Tolleson, AZ.",
        "public_id": "01a0110e-044f-718d-802b-6d8dc1b32009",
        "storage_key": "property/6767906449166442/01a0110e-044f-718d-802b-6d8dc1b32009.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and games at our community barbecue area, complete with grills, comfortable seating, and fun cornhole boards.",
      "link": "",
      "alt_text": "Outdoor barbecue area with grills, seating, and cornhole boards at Parc Lofts in Tolleson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6936a48b-c865-4f1c-9b30-62ae5941b435",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/01a0110d-fef9-7123-8b81-fced3718fb1c.webp",
      "image_media": {
        "alt_text": "Dog washing station in community pet spa.",
        "public_id": "01a0110d-fef9-7123-8b81-fced3718fb1c",
        "storage_key": "property/6767906449166442/01a0110d-fef9-7123-8b81-fced3718fb1c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Groom your furry friend at our convenient on-site pet spa, featuring a professional-grade dog washing station.",
      "link": "",
      "alt_text": "Dog washing station in community pet spa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c9badc93-c7f0-4a98-ba93-4479b3e2b352",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/01a0110d-d13e-77e7-a3f3-cc2bdad72b06.webp",
      "image_media": {
        "alt_text": "Mailroom with mailboxes and package lockers at Parc Lofts in Tolleson, AZ.",
        "public_id": "01a0110d-d13e-77e7-a3f3-cc2bdad72b06",
        "storage_key": "property/6767906449166442/01a0110d-d13e-77e7-a3f3-cc2bdad72b06.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Secure mailroom featuring individual mailboxes and convenient package lockers for residents.",
      "link": "",
      "alt_text": "Mailroom with mailboxes and package lockers at Parc Lofts in Tolleson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0f361803-57cb-4a02-ba3a-8bd4a9073aeb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/01a0110d-b6cc-77f0-96f0-26950f403083.webp",
      "image_media": {
        "alt_text": "Outdoor courtyard with artificial turf, seating, and dog amenities.",
        "public_id": "01a0110d-b6cc-77f0-96f0-26950f403083",
        "storage_key": "property/6767906449166442/01a0110d-b6cc-77f0-96f0-26950f403083.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the beautifully landscaped courtyard, complete with artificial turf, comfortable seating, and dedicated amenities for your furry friends.",
      "link": "",
      "alt_text": "Outdoor courtyard with artificial turf, seating, and dog amenities.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2a0a3014-f8f5-4ce5-8caa-80705c097e66",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f66a5-c4c5-75fb-a420-4ae905a77ee1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and white countertops opening into a living area.",
        "public_id": "019f66a5-c4c5-75fb-a420-4ae905a77ee1",
        "storage_key": "property/6767906449166442/019f66a5-c4c5-75fb-a420-4ae905a77ee1.webp",
        "width": 1920,
        "height": 1277
      },
      "title": "Apartment",
      "description": "Experience the perfect blend of style and functionality in our modern kitchens, featuring sleek dark wood cabinetry, premium stainless steel appliances, and elegant quartz countertops.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and white countertops opening into a living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9b3c119e-ac08-4f49-bc44-a637b33107e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/01a0110e-0da1-759b-b5f2-227543d7d2ce.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark cabinetry, and a white island with bar stools.",
        "public_id": "01a0110e-0da1-759b-b5f2-227543d7d2ce",
        "storage_key": "property/6767906449166442/01a0110e-0da1-759b-b5f2-227543d7d2ce.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this modern kitchen featuring stainless steel appliances, ample cabinet space, and a convenient breakfast bar with seating.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, dark cabinetry, and a white island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3d690cde-245a-44db-9975-adb909901351",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f66a5-c4f5-736f-86d7-a7e4bc8de5b9.webp",
      "image_media": {
        "alt_text": "A modern living room with a sofa, armchair, coffee table, and a view of the kitchen with bar stools at Parc Lofts in Tolleson, AZ.",
        "public_id": "019f66a5-c4f5-736f-86d7-a7e4bc8de5b9",
        "storage_key": "property/6767906449166442/019f66a5-c4f5-736f-86d7-a7e4bc8de5b9.webp",
        "width": 1920,
        "height": 1277
      },
      "title": "Apartment",
      "description": "Step into this stylish living area, featuring a comfortable sofa, accent armchair, and a chic coffee table. The open-concept design seamlessly connects to a modern kitchen with a convenient breakfast bar.",
      "link": "",
      "alt_text": "A modern living room with a sofa, armchair, coffee table, and a view of the kitchen with bar stools at Parc Lofts in Tolleson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7bbb0da3-7172-4297-9906-e53bbaf16329",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f66a5-cf4c-73b8-b1be-8de09b4bd4ae.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a large bed, nightstand, and an ensuite bathroom visible through an open doorway at Parc Lofts in Tolleson, AZ.",
        "public_id": "019f66a5-cf4c-73b8-b1be-8de09b4bd4ae",
        "storage_key": "property/6767906449166442/019f66a5-cf4c-73b8-b1be-8de09b4bd4ae.webp",
        "width": 1920,
        "height": 1277
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush bed and easy access to a modern ensuite bathroom.",
      "link": "",
      "alt_text": "Cozy bedroom with a large bed, nightstand, and an ensuite bathroom visible through an open doorway at Parc Lofts in Tolleson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a313b379-b343-470e-bba4-7932572ca50f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f66a5-cf4a-733d-a41f-95460bd77b71.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and walk-in closet at Parc Lofts in Tolleson, AZ.",
        "public_id": "019f66a5-cf4a-733d-a41f-95460bd77b71",
        "storage_key": "property/6767906449166442/019f66a5-cf4a-733d-a41f-95460bd77b71.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a double vanity, a large mirror, a private toilet area, and a walk-in closet with ample shelving.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and walk-in closet at Parc Lofts in Tolleson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f0c8d440-896d-40c1-bbac-4272b3f22dac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f66a5-d061-70e1-9a2e-748451d74e12.webp",
      "image_media": {
        "alt_text": "Luxurious bedroom with a king-size bed, plush bedding, and modern art at Parc Lofts in Tolleson, AZ.",
        "public_id": "019f66a5-d061-70e1-9a2e-748451d74e12",
        "storage_key": "property/6767906449166442/019f66a5-d061-70e1-9a2e-748451d74e12.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in this spacious bedroom, featuring a king-size bed, elegant decor, and a serene ambiance.",
      "link": "",
      "alt_text": "Luxurious bedroom with a king-size bed, plush bedding, and modern art at Parc Lofts in Tolleson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_aaf8ae0e-7d6f-47f7-838f-652d94fa6ad5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Desert Sky Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7611 W Thomas Rd, Phoenix, AZ 85033, USA",
      "poi_short_description": "Clean shopping arcade with a playground, movie theaters and swap meet for electronics and Mexican snacks.",
      "poi_long_description": "People say this shopping center offers a variety of stores and services, including a carousel and electric trackless train. They also highlight the reasonable prices, good deals, and the old-school mall vibe, which is great for walking.\n\nOther reviews mention the mall can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-94ca-7409-8ba7-31d172dafcc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-94ca-7409-8ba7-31d172dafcc0",
        "storage_key": "property/6767906449166442/019d02ca-94ca-7409-8ba7-31d172dafcc0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.desertskymall.com/?utm_source=google&utm_medium=onlinesearch&utm_content=gmp_website_button&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=5353196390973648747&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "desert-sky-mall",
      "poi_latitude": "33.4769375",
      "poi_longitude": "-112.2249003",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 623-245-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c344-757b-8351-482ec44eea9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c344-757b-8351-482ec44eea9b",
        "storage_key": "property/6767906449166442/019d02ca-c344-757b-8351-482ec44eea9b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJryIPX2gVK4cRay_jUMFfSko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_0f389572-bb09-4ea9-abcb-d467d002ed1f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "7333 W McDowell Rd, Phoenix, AZ 85035, USA",
      "poi_short_description": "Chain carrying tools and equipment, along with garden supplies and appliances.",
      "poi_long_description": "People say this home improvement store has helpful employees who can assist in finding the right parts and products. They also highlight the friendly and knowledgeable staff who provide great customer service.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-9500-7249-89c6-af5b658c63e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-9500-7249-89c6-af5b658c63e4",
        "storage_key": "property/6767906449166442/019d02ca-9500-7249-89c6-af5b658c63e4.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Mcdowell/AZ/Phoenix/85035/455?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13181049534492807327&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.4645183",
      "poi_longitude": "-112.2179712",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 623-849-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c344-757b-8351-482ec44eea9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c344-757b-8351-482ec44eea9b",
        "storage_key": "property/6767906449166442/019d02ca-c344-757b-8351-482ec44eea9b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJS5Q8kHMVK4cRn5BFJrd-7LY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_da09797f-2fc2-481e-a8b8-11e5094b9dc2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7400 W Encanto Blvd, Phoenix, AZ 85035, USA",
      "poi_short_description": "High-value gym chain featuring a variety of equipment, plus group classes, and a pool.",
      "poi_long_description": "People say this gym has a wide variety of modern, clean equipment, and a friendly, helpful staff. They also highlight the gym's spacious layout, convenient location, and great value for the price.\n\nSome reviews mention the gym can be crowded during peak hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-a1ce-74a3-b306-770afe1d850f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-a1ce-74a3-b306-770afe1d850f",
        "storage_key": "property/6767906449166442/019d02ca-a1ce-74a3-b306-770afe1d850f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/phoenix-75th-aveencanto/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15695482801901019761&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "33.4738021",
      "poi_longitude": "-112.2183848",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 480-210-6729",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c76f-7380-8d5d-8bacad4d6c5e",
        "storage_key": "property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW-usFT8VK4cRcSKQOXOO0dk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_58e3d91e-afdb-4b71-912d-8143ecfb4d43",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Mountainside Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10435 W McDowell Rd, Avondale, AZ 85392, USA",
      "poi_short_description": "Large, locally owned gym featuring classes and lots of equipment, plus friendly staff and childcare.",
      "poi_long_description": "People say this fitness center offers a variety of gym equipment, machines, and classes, including muscle endurance and core workouts, as well as amenities like a sauna, cold plunge, and childcare. They highlight the welcoming atmosphere, the knowledgeable trainers, and the helpful and friendly staff. They also like the clean and well-maintained facility.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-a568-728e-a359-4fa273862e27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-a568-728e-a359-4fa273862e27",
        "storage_key": "property/6767906449166442/019d02ca-a568-728e-a359-4fa273862e27.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://mountainsidefitness.com/clubs/avondale/?utm_source=GMB&utm_medium=Local&utm_campaign=Avondale%20Club&utm_content=WebsiteLink",
      "poi_directions_map_url": "https://maps.google.com/?cid=14845768426956053507&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mountainside-fitness",
      "poi_latitude": "33.4630251",
      "poi_longitude": "-112.2834988",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 623-440-5911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c76f-7380-8d5d-8bacad4d6c5e",
        "storage_key": "property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9zZvMEM_K4cRA9xsYrrDBs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_8471722d-2821-4dd0-9504-f1a1a7d91299",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Shopping & Retail",
      "poi_address": "10050 W McDowell Rd Suite 110, Avondale, AZ 85392, USA",
      "poi_short_description": "Popular cosmetics retailer featuring a salon, plus skincare, makeup, fragrance and hair products.",
      "poi_long_description": "People say this cosmetics store offers a wide variety of perfumes and makeup, with samples available to try. They also highlight the convenience of the location.\n\nSome reviews mention the customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-a723-72e9-99d2-aca37fdec3b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-a723-72e9-99d2-aca37fdec3b8",
        "storage_key": "property/6767906449166442/019d02ca-a723-72e9-99d2-aca37fdec3b8.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/avondale-az-1132",
      "poi_directions_map_url": "https://maps.google.com/?cid=5868843919499813938&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "33.4673842",
      "poi_longitude": "-112.2762064",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 480-770-3880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c76f-7380-8d5d-8bacad4d6c5e",
        "storage_key": "property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnRPsa1g_K4cRMmT_R3NSclE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_a758e431-3183-4efb-a13c-e8be756dc18a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7333 W Thomas Rd #78, Phoenix, AZ 85033, USA",
      "poi_short_description": "Workout venue featuring treadmills, free weights and weight machines (some with massage areas) as well as showers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-a6de-74c3-a4a2-7e432e93f621.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-a6de-74c3-a4a2-7e432e93f621",
        "storage_key": "property/6767906449166442/019d02ca-a6de-74c3-a4a2-7e432e93f621.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/phoenix-west-az?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=9175628663140348894&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.4791205",
      "poi_longitude": "-112.2180009",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 623-344-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c76f-7380-8d5d-8bacad4d6c5e",
        "storage_key": "property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEaoYCsbpQIYR3nNfkadhVn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5ee437a5-0521-40f0-937f-b9d30003a877",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "BluePearl Pet Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "13034 W Rancho Santa Fe Blvd Ste. 101, Avondale, AZ 85392, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-a761-7058-8197-a311fce8c350.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-a761-7058-8197-a311fce8c350",
        "storage_key": "property/6767906449166442/019d02ca-a761-7058-8197-a311fce8c350.webp",
        "width": 1024,
        "height": 587
      },
      "poi_business_url": "https://bluepearlvet.com/hospital/avondale-az/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7929150564691392023&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluepearl-pet-hospital",
      "poi_latitude": "33.4617039",
      "poi_longitude": "-112.3363964",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 623-385-4555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c76f-7380-8d5d-8bacad4d6c5e",
        "storage_key": "property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGV5JArU4K4cRF7YEm20ACm4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_e2386fc2-db2f-4555-977c-dc2f33976b42",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7640 W Thomas Rd, Phoenix, AZ 85033, USA",
      "poi_short_description": "Basketball and racquetball courts at this health club with cardio equipment, strength machines and a pool.",
      "poi_long_description": "People say this gym offers a great place to play basketball, has a wide range of well-maintained equipment, and is very clean with friendly and helpful staff. They also highlight the great customer service, easy sign-up process, and motivating atmosphere.\n\nSome reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-ab7e-740a-9f64-057617821351.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-ab7e-740a-9f64-057617821351",
        "storage_key": "property/6767906449166442/019d02ca-ab7e-740a-9f64-057617821351.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=50&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6020149682764692760&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.48153840000001",
      "poi_longitude": "-112.2232194",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 623-845-9920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c76f-7380-8d5d-8bacad4d6c5e",
        "storage_key": "property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX7CbX0IVK4cRGL3ehz3ei1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_70049ff3-11af-40e7-b90a-bb8b1023696a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Abrazo West Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "13677 W McDowell Rd, Goodyear, AZ 85395, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-abf4-735f-98a5-f0ec1f3ab806.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-abf4-735f-98a5-f0ec1f3ab806",
        "storage_key": "property/6767906449166442/019d02ca-abf4-735f-98a5-f0ec1f3ab806.webp",
        "width": 1280,
        "height": 643
      },
      "poi_business_url": "https://www.abrazohealth.com/locations/detail/abrazo-west-campus/?utm_campaign=gmb_listings_mgmt&utm_source=gmb-abrazo-west-campus&utm_medium=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1072554981668413270&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "abrazo-west-campus",
      "poi_latitude": "33.4616973",
      "poi_longitude": "-112.3534925",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 623-882-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c780-741b-aede-76703fdffcbf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c780-741b-aede-76703fdffcbf",
        "storage_key": "property/6767906449166442/019d02ca-c780-741b-aede-76703fdffcbf.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_3qLcbw4K4cRVt9rvBJ74g4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_5f54d86c-13a9-4c6d-9b0d-6c4f59a52c48",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Banner Estrella Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "9201 W Thomas Rd, Phoenix, AZ 85037, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-ac71-712e-b5b4-e26a44e23b6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-ac71-712e-b5b4-e26a44e23b6d",
        "storage_key": "property/6767906449166442/019d02ca-ac71-712e-b5b4-e26a44e23b6d.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/phoenix/banner-estrella-medical-center?y_source=1_MTE5MDczNjUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11847918637679302131&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "banner-estrella-medical-center",
      "poi_latitude": "33.4783538",
      "poi_longitude": "-112.257931",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 623-327-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c780-741b-aede-76703fdffcbf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c780-741b-aede-76703fdffcbf",
        "storage_key": "property/6767906449166442/019d02ca-c780-741b-aede-76703fdffcbf.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ45ieeOs_K4cR89WaXjpDbKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b0cba9d9-b58b-427b-ad0d-6774ba76fef8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Friendship Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12325 W McDowell Rd, Avondale, AZ 85323, USA",
      "poi_short_description": "Playgrounded park with baseball and soccer fields, plus a splash pad and tennis courts.",
      "poi_long_description": "People say this park offers a variety of activities, including playgrounds, sports fields, a dog park, a fishing pond, and a splash pad. They highlight the park's clean and well-maintained facilities, as well as the family-friendly vibe. They also like the scenic walking trail and the ample parking. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-ad87-72ae-ae6e-2f2d2be8e70a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-ad87-72ae-ae6e-2f2d2be8e70a",
        "storage_key": "property/6767906449166442/019d02ca-ad87-72ae-ae6e-2f2d2be8e70a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.avondaleaz.gov/government/departments/parks-recreation/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=17309830429229523955&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "friendship-park",
      "poi_latitude": "33.4604627",
      "poi_longitude": "-112.3226161",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 623-333-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c7d8-7409-9c4f-b83b67a6f490.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c7d8-7409-9c4f-b83b67a6f490",
        "storage_key": "property/6767906449166442/019d02ca-c7d8-7409-9c4f-b83b67a6f490.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt_rvMEg_K4cR8yN5YBDfOPA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5809b997-e555-4a85-bd57-47e15c901cea",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Glendale Heroes Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "83rd Avenue and, Bethany Home Rd, Glendale, AZ 85303, USA",
      "poi_short_description": "Park featuring a playground for kids as well as a lake for fishing and a dog park for furry friends.",
      "poi_long_description": "People say this park offers a variety of amenities, including basketball courts, a splash pad, a skate park, a playground, a library, and a lake for fishing. They highlight the clean restrooms, walking paths, and shaded areas, as well as the family-friendly and safe atmosphere. They also like the accessible parking and sidewalks, and the beautiful views, especially at sunset. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-b127-70a8-83dd-32db5982e8ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-b127-70a8-83dd-32db5982e8ee",
        "storage_key": "property/6767906449166442/019d02ca-b127-70a8-83dd-32db5982e8ee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.glendaleaz.com/parksandrecreation/GlendaleHeroesPark.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=15557125583860822947&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glendale-heroes-regional-park",
      "poi_latitude": "33.5263956",
      "poi_longitude": "-112.2364476",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 623-930-2820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c7d8-7409-9c4f-b83b67a6f490.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c7d8-7409-9c4f-b83b67a6f490",
        "storage_key": "property/6767906449166442/019d02ca-c7d8-7409-9c4f-b83b67a6f490.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjd7tH5xqK4cRo3MqGEsD5tc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_491ee68f-e62d-4464-8e59-414bde930836",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Grand Canyon University Championship Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5902 W Indian School Rd, Phoenix, AZ 85033, USA",
      "poi_short_description": "Public golf course featuring well-maintained greens and fairways, plus food service.",
      "poi_long_description": "People say this golf course offers a fun and challenging layout with well-maintained fairways and greens. They also highlight the great value, walkable course, and friendly service from the staff and beverage cart.\n\nOther reviews mention the sand traps can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-b10a-730b-9b92-78eaeb8f3ffb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-b10a-730b-9b92-78eaeb8f3ffb",
        "storage_key": "property/6767906449166442/019d02ca-b10a-730b-9b92-78eaeb8f3ffb.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://gcugolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5740069318367373165&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "grand-canyon-university-championship-golf-course",
      "poi_latitude": "33.4959033",
      "poi_longitude": "-112.1877902",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 623-846-4022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c8e2-70ff-aeda-0f748f1b05e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c8e2-70ff-aeda-0f748f1b05e8",
        "storage_key": "property/6767906449166442/019d02ca-c8e2-70ff-aeda-0f748f1b05e8.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJw5NoJygVK4cRbednA6LSqE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_f4add62f-c21e-4b80-add9-6dcbef7afd8a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Palm Valley Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2211 N Litchfield Rd, Goodyear, AZ 85395, USA",
      "poi_short_description": "Designed by Arthur Hills, this 27-hole golf course has a driving range and other practice facilities.",
      "poi_long_description": "People say this golf course offers a fun layout and fast, true greens. They also highlight the nice patio for drinks after the round and the professional staff.\n\nOther reviews mention the course condition can be poor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-b1f5-744c-bddb-0f376efbb92a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-b1f5-744c-bddb-0f376efbb92a",
        "storage_key": "property/6767906449166442/019d02ca-b1f5-744c-bddb-0f376efbb92a.webp",
        "width": 800,
        "height": 509
      },
      "poi_business_url": "http://www.palmvalleygolf.com/?utm_source=google&utm_medium=organic&utm_campaign=google_business_profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=10450760988907081185&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "palm-valley-golf-club",
      "poi_latitude": "33.4708018",
      "poi_longitude": "-112.3569774",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 623-935-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c8e2-70ff-aeda-0f748f1b05e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c8e2-70ff-aeda-0f748f1b05e8",
        "storage_key": "property/6767906449166442/019d02ca-c8e2-70ff-aeda-0f748f1b05e8.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJW37ddKE4K4cR4Q1RuL-PCJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_b50ac5d8-004c-434b-805a-dfcf47cdd6c0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Alamar Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4155 S El Mirage Rd, Avondale, AZ 85323, USA",
      "poi_short_description": "Family-friendly park featuring baseball and soccer fields, basketball and tennis courts, a dog park, and playgrounds plus a fishing lake.",
      "poi_long_description": "Visitors say this park is clean and well-maintained, with plenty of walking paths, playgrounds, and sports facilities, including baseball fields, basketball courts, and tennis courts. They also highlight the park's safety, thanks to its good lighting, and its family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-b3b5-746a-b183-efcfc9aa017d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-b3b5-746a-b183-efcfc9aa017d",
        "storage_key": "property/6767906449166442/019d02ca-b3b5-746a-b183-efcfc9aa017d.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://www.avondaleaz.gov/government/departments/parks-recreation/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=12902282512567115620&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alamar-park",
      "poi_latitude": "33.4081873",
      "poi_longitude": "-112.3210753",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 623-333-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c7d8-7409-9c4f-b83b67a6f490.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c7d8-7409-9c4f-b83b67a6f490",
        "storage_key": "property/6767906449166442/019d02ca-c7d8-7409-9c4f-b83b67a6f490.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJubpwhOM_K4cRZB9MAZYdDrM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_734e16d3-6a65-4cdc-8fb6-0b59c05d1eca",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Glendale Regional Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6801 N Glen Harbor Blvd, Glendale, AZ 85307, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-b65c-73bb-8d9a-b743b47c0cfc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-b65c-73bb-8d9a-b743b47c0cfc",
        "storage_key": "property/6767906449166442/019d02ca-b65c-73bb-8d9a-b743b47c0cfc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.glendaleaz.com/live/amenities/airport___municipal",
      "poi_directions_map_url": "https://maps.google.com/?cid=6794599642740604503&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glendale-regional-airport",
      "poi_latitude": "33.5296849",
      "poi_longitude": "-112.2972206",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 623-930-2188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-cbba-708f-9be7-a7a7545eb394.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-cbba-708f-9be7-a7a7545eb394",
        "storage_key": "property/6767906449166442/019d02ca-cbba-708f-9be7-a7a7545eb394.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJA0ED0OVAK4cRV76MMGBES14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_f9420d48-450d-472b-9282-da9f2f64b93a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Glendale Airport Hangars",
      "poi_type": "Transportation & Transit",
      "poi_address": "6635 N Glen Harbor Blvd, Glendale, AZ 85307, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-b79f-76fb-93be-b65f20f352b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-b79f-76fb-93be-b65f20f352b7",
        "storage_key": "property/6767906449166442/019d02ca-b79f-76fb-93be-b65f20f352b7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.glendalehangars.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2167914040134275342&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glendale-airport-hangars",
      "poi_latitude": "33.5258118",
      "poi_longitude": "-112.2994901",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 623-476-4765",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-cbba-708f-9be7-a7a7545eb394.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-cbba-708f-9be7-a7a7545eb394",
        "storage_key": "property/6767906449166442/019d02ca-cbba-708f-9be7-a7a7545eb394.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJLYoc0OVAK4cRDhHJWVX6FR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_9d23c634-965b-4c9d-a872-eda246c39410",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Pepsi Gatorade DC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "860 South 75th Avenue, Tolleson, AZ 85353, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-b840-74db-9599-1384a69ea965.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-b840-74db-9599-1384a69ea965",
        "storage_key": "property/6767906449166442/019d02ca-b840-74db-9599-1384a69ea965.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17242266875067633265&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pepsi-gatorade-dc",
      "poi_latitude": "33.4395584",
      "poi_longitude": "-112.2228159",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c76f-7380-8d5d-8bacad4d6c5e",
        "storage_key": "property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJyCrtVcVK4cRcQ7kkl7WSO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_8025fbbb-822e-4f54-804f-141756b7741e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "City of Avondale",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11465 West, 11465 W Civic Ctr Dr, Avondale, AZ 85323, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-ba29-72ed-9613-1e658214970b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-ba29-72ed-9613-1e658214970b",
        "storage_key": "property/6767906449166442/019d02ca-ba29-72ed-9613-1e658214970b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.avondaleaz.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13622991710836474318&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-avondale",
      "poi_latitude": "33.4444488",
      "poi_longitude": "-112.3044385",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 623-333-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-cd0b-7674-b532-fc2575c9fb00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-cd0b-7674-b532-fc2575c9fb00",
        "storage_key": "property/6767906449166442/019d02ca-cd0b-7674-b532-fc2575c9fb00.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6rqDB4_K4cRzsF_hsiWDr0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_3896329a-b187-44c0-97fd-26b05f618b07",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "JBS Beef Plant TollesonAZ - Business Access",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8990 W Buckeye Rd, Tolleson, AZ 85353, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5742067192014743564&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jbs-beef-plant-tollesonaz---business-access",
      "poi_latitude": "33.4359509",
      "poi_longitude": "-112.2525141",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 623-476-4110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c76f-7380-8d5d-8bacad4d6c5e",
        "storage_key": "property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs5Jq-ao_K4cRDKh2OLDrr08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_04db935b-05e3-40d4-b54e-7a7e6795d382",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Global Security Operations Center - Amazon",
      "poi_type": "Major Employers & Offices",
      "poi_address": "50003354, 555 N Litchfield Rd work, Goodyear, AZ 85338, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-be37-72c8-8842-73ffeffe916a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-be37-72c8-8842-73ffeffe916a",
        "storage_key": "property/6767906449166442/019d02ca-be37-72c8-8842-73ffeffe916a.webp",
        "width": 1280,
        "height": 802
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14996783210027426594&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "global-security-operations-center---amazon",
      "poi_latitude": "33.4532985",
      "poi_longitude": "-112.3576078",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c76f-7380-8d5d-8bacad4d6c5e",
        "storage_key": "property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-7gu5VI5K4cRIiM6h99GH9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_967b94d9-5942-4a23-9322-3c91c31d2c10",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Conair Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7475 N Glen Harbor Blvd, Glendale, AZ 85307, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-be35-77c1-a346-50276c97ad30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ca-be35-77c1-a346-50276c97ad30",
        "storage_key": "property/6767906449166442/019d02ca-be35-77c1-a346-50276c97ad30.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.conair.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9226046055308480358&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "conair-corporation",
      "poi_latitude": "33.5415218",
      "poi_longitude": "-112.2857174",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 623-872-8750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c76f-7380-8d5d-8bacad4d6c5e",
        "storage_key": "property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2QzD8QdBK4cRZk8OcAGACYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_079758c1-93d2-4796-ba9f-a2e7497df973",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Roma23",
      "poi_type": "Restaurants",
      "poi_address": "9118 W Van Buren St, Tolleson, AZ 85353, USA",
      "poi_short_description": "Trendy pizzeria delivering wood-fired pies, pasta dishes such as carbonara and lasagna.",
      "poi_long_description": "People say this Italian restaurant serves delicious wings, pizza, and pasta. They also highlight the friendly and attentive staff, and the cool atmosphere and decor.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019eb380-7373-72ad-9cba-4b7b8bea5a58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb380-7373-72ad-9cba-4b7b8bea5a58",
        "storage_key": "property/6767906449166442/019eb380-7373-72ad-9cba-4b7b8bea5a58.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://roma23.net/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=7124631742478620530&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "roma23",
      "poi_latitude": "33.45064620000001",
      "poi_longitude": "-112.2559813",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-597-5811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c326-7204-a595-6da999824e31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c326-7204-a595-6da999824e31",
        "storage_key": "property/6767906449166442/019d02ca-c326-7204-a595-6da999824e31.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy01grXc_K4cRchfpZdLG32I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_c3e9c6a1-e5e3-4ebb-b717-45e33134d443",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Angry Crab Shack",
      "poi_type": "Restaurants",
      "poi_address": "301 N Litchfield Rd, Goodyear, AZ 85338, USA",
      "poi_short_description": "",
      "poi_long_description": "Diners say this seafood restaurant serves up delicious seafood boil with popular choices like the trifecta spice blend, lobster tail, shrimp, corn, and potatoes. They also highlight the friendly and attentive service, reasonable prices, and fun atmosphere.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019eb380-6a47-72ea-85f3-5c06a008e0b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb380-6a47-72ea-85f3-5c06a008e0b1",
        "storage_key": "property/6767906449166442/019eb380-6a47-72ea-85f3-5c06a008e0b1.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.angrycrabshack.com/litchfield-rd-goodyear-az",
      "poi_directions_map_url": "https://maps.google.com/?cid=14673110059201309065&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "angry-crab-shack",
      "poi_latitude": "33.4502781",
      "poi_longitude": "-112.3588284",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 480-878-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c326-7204-a595-6da999824e31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c326-7204-a595-6da999824e31",
        "storage_key": "property/6767906449166442/019d02ca-c326-7204-a595-6da999824e31.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5chAa-o4K4cRiannfNtbocs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_ad3bff40-53a8-482f-b5a8-60b3066219d0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Nineteen 86 Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "9431 W Northern Ave, Glendale, AZ 85305, USA",
      "poi_short_description": "Fashionable choice specializing in steak & seafood dishes, plus spirits, wine & craft cocktails.",
      "poi_long_description": "Diners praise the delicious and perfectly cooked steaks served at this steakhouse, which also boasts a wide variety of appetizers and sides. Guests consistently praise the attentive service and appreciate the elegant and relaxing atmosphere.\n\nSome reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019eb380-6c6c-73c8-8cb9-3d3bb2d7e629.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb380-6c6c-73c8-8cb9-3d3bb2d7e629",
        "storage_key": "property/6767906449166442/019eb380-6c6c-73c8-8cb9-3d3bb2d7e629.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ddcaz.com/west-valley/dining-nightlife/nineteen-86-steakhouse",
      "poi_directions_map_url": "https://maps.google.com/?cid=12909303419752364561&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "nineteen-86-steakhouse",
      "poi_latitude": "33.5466238",
      "poi_longitude": "-112.2613146",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-633-8986",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c326-7204-a595-6da999824e31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c326-7204-a595-6da999824e31",
        "storage_key": "property/6767906449166442/019d02ca-c326-7204-a595-6da999824e31.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx3HUU8tBK4cREToTWBAPJ7M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_f1db0ca9-db66-4774-9f1b-6298516fecc7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Pier 88 Boiling Seafood & Bar Avondale",
      "poi_type": "Restaurants",
      "poi_address": "10040 W McDowell Rd, Avondale, AZ 85392, USA",
      "poi_short_description": "Funky seafood eatery (part of a chain) serving Cajun-style boils and fried fare in a hands-on setting.",
      "poi_long_description": "People say this seafood restaurant serves delicious seafood boils, catfish, and fried oysters. They highlight the fresh, juicy seafood, bold Cajun spices, and flavorful sauces, as well as the generous portions and reasonable prices. They also like the friendly and attentive staff, and the fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019eb380-6a1c-73f8-869b-976597c84902.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb380-6a1c-73f8-869b-976597c84902",
        "storage_key": "property/6767906449166442/019eb380-6a1c-73f8-869b-976597c84902.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.pier88seafood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4351276168344896632&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pier-88-boiling-seafood--bar-avondale",
      "poi_latitude": "33.4655369",
      "poi_longitude": "-112.2766363",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-742-4512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c326-7204-a595-6da999824e31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c326-7204-a595-6da999824e31",
        "storage_key": "property/6767906449166442/019d02ca-c326-7204-a595-6da999824e31.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJETDxzeY_K4cReATS_Z7WYjw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_bc04a873-9922-4756-9397-4cfbc2f252fd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2626 N 75th Ave, Phoenix, AZ 85035, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "People say this Italian restaurant serves tasty pasta, breadsticks, and soups, and offers a fresh salad. They also highlight the generous portions, classic favorites, and good specials.\n\nSome reviews mention there can be long wait times.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019eb380-6a8b-75be-93a5-3b31430dba2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb380-6a8b-75be-93a5-3b31430dba2a",
        "storage_key": "property/6767906449166442/019eb380-6a8b-75be-93a5-3b31430dba2a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.olivegarden.com/locations/az/phoenix/phoenix-desert-sky/1718?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:phoenix-az-1718_pl:locurl_rd:1566",
      "poi_directions_map_url": "https://maps.google.com/?cid=4602949348326312900&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "33.477551",
      "poi_longitude": "-112.221182",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-845-0477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c326-7204-a595-6da999824e31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c326-7204-a595-6da999824e31",
        "storage_key": "property/6767906449166442/019d02ca-c326-7204-a595-6da999824e31.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMySvnGkVK4cRxAsbegv24D8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_0c51c011-8417-4f76-9705-41a9f4a66eda",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "1616 N 75th Ave, Phoenix, AZ 85035, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Diners say this restaurant offers delicious steaks, ribs, and fresh, warm bread with cinnamon butter, with many appreciating the generous portions. They also highlight the friendly and attentive staff, the lively atmosphere, and the reasonable prices.\n\nSome reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019eb380-6a3c-77bb-95a7-ce2b78d30be7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb380-6a3c-77bb-95a7-ce2b78d30be7",
        "storage_key": "property/6767906449166442/019eb380-6a3c-77bb-95a7-ce2b78d30be7.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/arizona/phoenix-n-75th-ave?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=1364120851220386300&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "33.4673155",
      "poi_longitude": "-112.221091",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-247-4061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c326-7204-a595-6da999824e31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c326-7204-a595-6da999824e31",
        "storage_key": "property/6767906449166442/019d02ca-c326-7204-a595-6da999824e31.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE3Q8hHEVK4cR_NGxz69U7hI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_041b3caf-553e-494e-80c6-4fe91bfa966d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "PetSmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "1561 N Dysart Rd, Avondale, AZ 85392, USA",
      "poi_short_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_long_description": "Customers consistently praise this pet store for its wide variety of pet supplies, including specialty items, and its impressive, well-maintained aquatic section. Reviewers also highlight the friendly and knowledgeable staff, particularly in the good grooming salon.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019eb381-8603-75a6-8940-5d456f446abe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb381-8603-75a6-8940-5d456f446abe",
        "storage_key": "property/6767906449166442/019eb381-8603-75a6-8940-5d456f446abe.webp",
        "width": 1280,
        "height": 286
      },
      "poi_business_url": "https://www.petsmart.com/stores/us/az/avondale-store1082.html?utm_source=google&utm_medium=organic&utm_campaign=google-my-business",
      "poi_directions_map_url": "https://maps.google.com/?cid=1281253063911893039&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "petsmart",
      "poi_latitude": "33.4618592",
      "poi_longitude": "-112.3390857",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-547-0889",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c344-757b-8351-482ec44eea9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c344-757b-8351-482ec44eea9b",
        "storage_key": "property/6767906449166442/019d02ca-c344-757b-8351-482ec44eea9b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ3bno4NE4K4cRL2jZjd_sxxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_a28dc753-6d13-41c4-acc0-b051fad192cb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2020 N 75th Ave, Phoenix, AZ 85035, USA",
      "poi_short_description": "",
      "poi_long_description": "Customers report that this store features a wide selection of products available at good prices and maintains a clean environment.\n\nOther reviews mention the service can be unhelpful and slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019eb381-81d9-7359-9e23-fb82ac316f01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb381-81d9-7359-9e23-fb82ac316f01",
        "storage_key": "property/6767906449166442/019eb381-81d9-7359-9e23-fb82ac316f01.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1549-phoenix-az/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=15605651491236446122&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "33.47069159999999",
      "poi_longitude": "-112.223175",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-849-1030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c344-757b-8351-482ec44eea9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c344-757b-8351-482ec44eea9b",
        "storage_key": "property/6767906449166442/019d02ca-c344-757b-8351-482ec44eea9b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ46wYCW4VK4cRqn-xV1lpktg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_8b326e38-dad3-4835-bb36-5b172a9d788a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Hobby Lobby",
      "poi_type": "Shopping & Retail",
      "poi_address": "10045 W McDowell Rd, Avondale, AZ 85392, USA",
      "poi_short_description": "Chain carrying a variety of arts & crafts materials, plus party supplies, fabric & home-decor items.",
      "poi_long_description": "People say this store offers a wide selection of craft items, decor, and seasonal decorations, with many items frequently on sale. They also highlight the friendly and helpful staff, who are often described as knowledgeable. Visitors appreciate the store's spacious and well-organized layout, as well as its convenient parking and accessibility features.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019eb381-80a2-714a-b5ef-35455de38aae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb381-80a2-714a-b5ef-35455de38aae",
        "storage_key": "property/6767906449166442/019eb381-80a2-714a-b5ef-35455de38aae.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hobbylobby.com/stores/search/380",
      "poi_directions_map_url": "https://maps.google.com/?cid=9021662765873323100&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hobby-lobby",
      "poi_latitude": "33.463031",
      "poi_longitude": "-112.276423",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-643-9226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c344-757b-8351-482ec44eea9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c344-757b-8351-482ec44eea9b",
        "storage_key": "property/6767906449166442/019d02ca-c344-757b-8351-482ec44eea9b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNVD-X6M_K4cRXFw_m3xiM30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_0fd008a1-fd82-49b3-a70d-b29413199a33",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "9830 W Lower Buckeye Rd, Tolleson, AZ 85353, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Customers consistently praise this store for its good quality merchandise, wide variety of items, and well-stocked selection of fresh produce. Reviewers also frequently mention the clean and organized environment and the convenience of ample parking.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019eb381-8196-70d7-a756-b212f65f17e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb381-8196-70d7-a756-b212f65f17e1",
        "storage_key": "property/6767906449166442/019eb381-8196-70d7-a756-b212f65f17e1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/phoenix-sw/2149",
      "poi_directions_map_url": "https://maps.google.com/?cid=15518016037152816140&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "33.4233982",
      "poi_longitude": "-112.269665",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-687-2136",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c344-757b-8351-482ec44eea9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c344-757b-8351-482ec44eea9b",
        "storage_key": "property/6767906449166442/019d02ca-c344-757b-8351-482ec44eea9b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJk5SPtG4-K4cRDPxOKV4RW9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_ff9c8dc9-e5dc-42eb-9bbf-1002bffe22db",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Main Event Avondale",
      "poi_type": "Entertainment",
      "poi_address": "10315 W McDowell Rd, Avondale, AZ 85392, USA",
      "poi_short_description": "Casual restaurant and entertainment complex featuring bowling, laser tag, arcade games, and a ropes course.",
      "poi_long_description": "People say this restaurant offers good fries, pizza, and drinks, and has a fun atmosphere with bowling, laser tag, and arcade games. They also highlight the friendly and helpful staff, and the great deals and specials.\n\nOther reviews mention some arcade machines can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019eb383-5385-701d-b3af-c6e8de574278.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb383-5385-701d-b3af-c6e8de574278",
        "storage_key": "property/6767906449166442/019eb383-5385-701d-b3af-c6e8de574278.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mainevent.com/locations/arizona/avondale",
      "poi_directions_map_url": "https://maps.google.com/?cid=3874133869052112261&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "main-event-avondale",
      "poi_latitude": "33.4631462",
      "poi_longitude": "-112.2822341",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-936-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c326-7204-a595-6da999824e31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c326-7204-a595-6da999824e31",
        "storage_key": "property/6767906449166442/019d02ca-c326-7204-a595-6da999824e31.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH8YkQaE_K4cRhS0pVTqwwzU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_edbbbdac-eeb2-4cbe-a396-145a7f81b5f0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Gateway Pavilions",
      "poi_type": "Entertainment",
      "poi_address": "10020 W McDowell Rd, Avondale, AZ 85392, USA",
      "poi_short_description": "Open-air shopping center with national chain stores, fast-food outlets & a movie theater.",
      "poi_long_description": "People say this shopping center has a great selection of stores and restaurants, offering a variety of products at decent prices. They also highlight the ample parking and clean environment.\n\nSome reviews mention the customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019eb383-540e-7460-8503-ba68fa9bc6d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb383-540e-7460-8503-ba68fa9bc6d5",
        "storage_key": "property/6767906449166442/019eb383-540e-7460-8503-ba68fa9bc6d5.webp",
        "width": 950,
        "height": 1280
      },
      "poi_business_url": "https://www.harkins.com/theatres/gateway-pavilions-18",
      "poi_directions_map_url": "https://maps.google.com/?cid=8812892766448774251&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gateway-pavilions",
      "poi_latitude": "33.4664997",
      "poi_longitude": "-112.278553",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-478-9411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c344-757b-8351-482ec44eea9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c344-757b-8351-482ec44eea9b",
        "storage_key": "property/6767906449166442/019d02ca-c344-757b-8351-482ec44eea9b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwyCaY6M_K4cRa-zJQ0evTXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f8cd00b5-c967-469d-9558-6315607e7a01",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Tolleson Community Garden",
      "poi_type": "Entertainment",
      "poi_address": "557-599 N 93rd Ave, Tolleson, AZ 85353, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.tollesonaz.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9124320426516762385&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tolleson-community-garden",
      "poi_latitude": "33.4529314",
      "poi_longitude": "-112.2593323",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c7d8-7409-9c4f-b83b67a6f490.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c7d8-7409-9c4f-b83b67a6f490",
        "storage_key": "property/6767906449166442/019d02ca-c7d8-7409-9c4f-b83b67a6f490.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0e-T38o_K4cREU9fzxUZoH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9ac71c18-0ac2-4280-bebb-ac1e1235481b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Harkins Theatres Gateway Pavilions",
      "poi_type": "Entertainment",
      "poi_address": "10250 W McDowell Rd, Avondale, AZ 85392, USA",
      "poi_short_description": "Modern multiplex chain showing blockbusters & a few independent films; some venues offer childcare.",
      "poi_long_description": "Visitors say this movie theater offers delicious, fresh popcorn and a good variety of concessions, including chicken strips and fries. They also highlight the friendly and helpful staff, as well as the clean facilities.\n\nSome reviews mention the seating can be uncomfortable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019eb383-53a0-70ed-a3ae-318d42fb5e31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb383-53a0-70ed-a3ae-318d42fb5e31",
        "storage_key": "property/6767906449166442/019eb383-53a0-70ed-a3ae-318d42fb5e31.webp",
        "width": 1000,
        "height": 665
      },
      "poi_business_url": "https://harkins.com/theatres/gateway-pavilions/?utm_source=google_listing&utm_medium=web&utm_campaign=gmb&utm_id=local_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17715857636049801184&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "harkins-theatres-gateway-pavilions",
      "poi_latitude": "33.4664784",
      "poi_longitude": "-112.2806879",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-478-9411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019eb383-5ca1-732f-81b9-4618b6714fb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eb383-5ca1-732f-81b9-4618b6714fb7",
        "storage_key": "property/6767906449166442/019eb383-5ca1-732f-81b9-4618b6714fb7.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJbbEjVqM_K4cR4M8jSKhe2_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_067ebe6b-7d87-4bde-88db-6b59f953ceb1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Xtreme Air",
      "poi_type": "Entertainment",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4f55636e-2092-45d4-a3d9-1c72a3db9f43",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "The Room Escape Games",
      "poi_type": "Entertainment",
      "poi_address": "10210 W McDowell Rd #100, Avondale, AZ 85392, USA",
      "poi_short_description": "Decorated escape-room franchise with multiple themed rooms and an on-site bar.",
      "poi_long_description": "People say this escape room offers creative and fun rooms, with the \"Treasure Island\" and \"Blackout Motel\" themes being particularly popular. They also highlight the fair prices and the option to purchase alcohol while playing. Guests mention the staff are helpful, thorough, and provide excellent guidance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019eb383-5775-7158-b57b-6c77f56e0261.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb383-5775-7158-b57b-6c77f56e0261",
        "storage_key": "property/6767906449166442/019eb383-5775-7158-b57b-6c77f56e0261.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://theroomaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16288603143688665370&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-room-escape-games",
      "poi_latitude": "33.4669671",
      "poi_longitude": "-112.2797795",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-936-5524",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c76f-7380-8d5d-8bacad4d6c5e",
        "storage_key": "property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE1yfKpo_K4cRGrnfKkK-DOI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_5d349aff-f100-4c2b-aea0-8cec86cea26e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Desert Oasis Elementary School",
      "poi_type": "Education",
      "poi_address": "8802 W McDowell Rd, Phoenix, AZ 85037, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.tollesonschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16717928438311389889&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "desert-oasis-elementary-school",
      "poi_latitude": "33.4656544",
      "poi_longitude": "-112.2495601",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-533-3901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c32e-7604-b39a-d7c24cfa137e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c32e-7604-b39a-d7c24cfa137e",
        "storage_key": "property/6767906449166442/019d02ca-c32e-7604-b39a-d7c24cfa137e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS_Y4hto_K4cRwYrz2VYDAug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ba37a9d1-23ac-4725-b7fa-eb20ef6ac2b4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Tolleson Union High School",
      "poi_type": "Education",
      "poi_address": "9419 W Van Buren St, Tolleson, AZ 85353, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f012f-c420-70ed-a75e-aaf044facfbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f012f-c420-70ed-a75e-aaf044facfbb",
        "storage_key": "property/6767906449166442/019f012f-c420-70ed-a75e-aaf044facfbb.webp",
        "width": 1087,
        "height": 723
      },
      "poi_business_url": "http://www.tuhsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12959663036461877225&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tolleson-union-high-school",
      "poi_latitude": "33.4484418",
      "poi_longitude": "-112.2638294",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-478-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c32e-7604-b39a-d7c24cfa137e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c32e-7604-b39a-d7c24cfa137e",
        "storage_key": "property/6767906449166442/019d02ca-c32e-7604-b39a-d7c24cfa137e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyUP--Uo-K4cR6QcSUd742bM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_5ce51bd9-3292-4d9c-bbb3-6a4f0e49c003",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Tolleson Public Library",
      "poi_type": "Education",
      "poi_address": "Civic Center, 9055 W Van Buren St, Tolleson, AZ 85353, USA",
      "poi_short_description": "Public library in a brand-new facility offering free black-and-white printing.",
      "poi_long_description": "People say this library offers a wide range of books and many activities for children and families, including language learning resources. Visitors also highlight the beautiful building and the clean environment. They also mention the staff are friendly and helpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f012f-c489-714c-a901-63fc93309a7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f012f-c489-714c-a901-63fc93309a7d",
        "storage_key": "property/6767906449166442/019f012f-c489-714c-a901-63fc93309a7d.webp",
        "width": 720,
        "height": 542
      },
      "poi_business_url": "https://tollesonlibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3251101783169403865&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tolleson-public-library",
      "poi_latitude": "33.4499595",
      "poi_longitude": "-112.2541464",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-936-2746",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c32e-7604-b39a-d7c24cfa137e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c32e-7604-b39a-d7c24cfa137e",
        "storage_key": "property/6767906449166442/019d02ca-c32e-7604-b39a-d7c24cfa137e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAbiA1ko-K4cR2Ytzwtg7Hi0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_58198e07-1eb9-4654-8b57-e27d231ed3aa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Avondale Civic Center Library",
      "poi_type": "Education",
      "poi_address": "11350 W Civic Ctr Dr, Avondale, AZ 85323, USA",
      "poi_short_description": "Open library with friendly staffers and a play area for kids, plus a drive-thru drop-off.",
      "poi_long_description": "People say this public library offers a clean and quiet environment with friendly and helpful staff, as well as a great area for young kids with story time. They also highlight the knowledgeable staff and community events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f012f-c7ef-779a-812c-76789a9aa9fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f012f-c7ef-779a-812c-76789a9aa9fe",
        "storage_key": "property/6767906449166442/019f012f-c7ef-779a-812c-76789a9aa9fe.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "https://www.avondalelibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15168560920975526303&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "avondale-civic-center-library",
      "poi_latitude": "33.4450174",
      "poi_longitude": "-112.3028488",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-333-2665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c32e-7604-b39a-d7c24cfa137e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c32e-7604-b39a-d7c24cfa137e",
        "storage_key": "property/6767906449166442/019d02ca-c32e-7604-b39a-d7c24cfa137e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSZn6xB0_K4cRn0meiMqNgdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_562bdb6e-2f59-41e9-a72a-b03bc5713f8b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Desert Sky Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "7887 W Thomas Rd, Phoenix, AZ 85035, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.valleymetro.org/how-to-ride/transit-centers/desert-sky-transit-center/7887-w-thomas-rd",
      "poi_directions_map_url": "https://maps.google.com/?cid=6494946137379007140&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "desert-sky-transit-center",
      "poi_latitude": "33.4795609",
      "poi_longitude": "-112.2286164",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-253-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c76f-7380-8d5d-8bacad4d6c5e",
        "storage_key": "property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuXwvg6YVK4cRpGrFqRmvIlo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "custom_22ff7274-fee3-412f-b301-0f50b1d28ae3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Avondale Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "11401 W Hilton Wy, Avondale, AZ 85323, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.valleymetro.org/how-to-ride/park-and-ride/avondale-park-and-ride/11401-w-hilton-way",
      "poi_directions_map_url": "https://maps.google.com/?cid=7400368153941333789&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "avondale-park-and-ride",
      "poi_latitude": "33.4560454",
      "poi_longitude": "-112.3051486",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-253-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f012f-d015-761e-8a69-7c01a95901bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f012f-d015-761e-8a69-7c01a95901bf",
        "storage_key": "property/6767906449166442/019f012f-d015-761e-8a69-7c01a95901bf.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJoy5XMRc_K4cRHVfJjqBjs2Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_0b5e69e0-0f7d-4cfd-b5f3-7bc238340495",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Phoenix Sky Harbor International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3400 Sky Hbr Blvd, Phoenix, AZ 85034, USA",
      "poi_short_description": "This 3,000-acre airport serving the Phoenix area  features rail service & a variety of artwork.",
      "poi_long_description": "People say this airport offers a convenient sky train connecting terminals and the rental car center, and has a modern design with moving walkways. They also highlight the friendly staff, clean bathrooms, and easy navigation.\n\nOther reviews mention the airport can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f012f-c46d-7408-abc9-3bd304773495.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f012f-c46d-7408-abc9-3bd304773495",
        "storage_key": "property/6767906449166442/019f012f-c46d-7408-abc9-3bd304773495.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.skyharbor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9436507786966396482&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "phoenix-sky-harbor-international-airport",
      "poi_latitude": "33.435249",
      "poi_longitude": "-112.010124",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-273-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-cbba-708f-9be7-a7a7545eb394.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-cbba-708f-9be7-a7a7545eb394",
        "storage_key": "property/6767906449166442/019d02ca-cbba-708f-9be7-a7a7545eb394.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpXADM1wOK4cRQu5W4tU19YI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_f05e89c3-012d-4e5f-a6d6-ffd4e3f2c9d7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "79th Ave / I-10 Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "1509 N 79th Ave, Phoenix, AZ 85035, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f012f-c674-7003-96a9-3d72cb3acd10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f012f-c674-7003-96a9-3d72cb3acd10",
        "storage_key": "property/6767906449166442/019f012f-c674-7003-96a9-3d72cb3acd10.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.valleymetro.org/how-to-ride/park-and-ride/79th-ave-i-10-park-and-ride/1509-n-79th-ave",
      "poi_directions_map_url": "https://maps.google.com/?cid=9414589365106109359&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "79th-ave--i-10-park-and-ride",
      "poi_latitude": "33.46463980000001",
      "poi_longitude": "-112.2291388",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-253-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f012f-d015-761e-8a69-7c01a95901bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f012f-d015-761e-8a69-7c01a95901bf",
        "storage_key": "property/6767906449166442/019f012f-d015-761e-8a69-7c01a95901bf.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJvzHcV3cVK4cRr-tRnSVXp4I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_31459c18-735c-42c0-a77c-d8b670f41f89",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Sysco Arizona - Food Distributor & Restaurant Supplies",
      "poi_type": "Major Employers & Offices",
      "poi_address": "611 S 80th Ave, Tolleson, AZ 85353, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f012f-c469-7259-8add-89892265ea51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f012f-c469-7259-8add-89892265ea51",
        "storage_key": "property/6767906449166442/019f012f-c469-7259-8add-89892265ea51.webp",
        "width": 1200,
        "height": 628
      },
      "poi_business_url": "https://cloud.email.sysco.com/become-a-customer?utm_medium=googlemybusiness&utm_source=google.com&utm_campaign=gmb_opcopages&utm_content=arizona",
      "poi_directions_map_url": "https://maps.google.com/?cid=12493115309758818025&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sysco-arizona---food-distributor--restaurant-supplies",
      "poi_latitude": "33.4426407",
      "poi_longitude": "-112.2312069",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-936-9920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c76f-7380-8d5d-8bacad4d6c5e",
        "storage_key": "property/6767906449166442/019d02ca-c76f-7380-8d5d-8bacad4d6c5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI0s5vY4VK4cR6SYr0C52YK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wholesaler"
    },
    {
      "id": "custom_8f163075-65be-468b-8c0c-a4ae81559ef1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Festival Fields Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "101 E Lower Buckeye Rd, Avondale, AZ 85323, USA",
      "poi_short_description": "Grass-free, kid-friendly park (also for adults) with a skateboard area as well as a splash pad, a lake, and ball fields.",
      "poi_long_description": "Visitors say this park offers a splash pad, playground, skate park, pump track, soccer fields, and a lake for fishing. They also highlight that the park is clean and well-maintained, with plenty of space for picnics and parties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f012f-c99a-7559-a8cf-850241516967.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f012f-c99a-7559-a8cf-850241516967",
        "storage_key": "property/6767906449166442/019f012f-c99a-7559-a8cf-850241516967.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11965206082426049739&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "festival-fields-park",
      "poi_latitude": "33.4189918",
      "poi_longitude": "-112.349516",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-333-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c7d8-7409-9c4f-b83b67a6f490.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c7d8-7409-9c4f-b83b67a6f490",
        "storage_key": "property/6767906449166442/019d02ca-c7d8-7409-9c4f-b83b67a6f490.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWcA2js5K4cRyxRZn4nzDKY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_02f8a59b-8d08-4706-a978-3123079b510e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Hurley Ranch YMCA Preschool",
      "poi_type": "Education",
      "poi_address": "8950 W Illini St, Tolleson, AZ 85353, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://valleyymca.org/programs/child-care/early-learning/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16017514405647407085&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hurley-ranch-ymca-preschool",
      "poi_latitude": "33.412514",
      "poi_longitude": "-112.2528853",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 602-404-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c32e-7604-b39a-d7c24cfa137e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c32e-7604-b39a-d7c24cfa137e",
        "storage_key": "property/6767906449166442/019d02ca-c32e-7604-b39a-d7c24cfa137e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV04qLM4_K4cR7ddQzXykSd4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_408574d7-5907-494b-9adc-918f05db7c56",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "poi_name": "Sunrise Preschools",
      "poi_type": "Education",
      "poi_address": "350 N 96th Ave, Tolleson, AZ 85353, USA",
      "poi_short_description": "Daycare, preschool and childcare facility offering learning activities such as art for kids from infancy through elementary school.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019f060b-e723-753b-b704-eeb506c142be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f060b-e723-753b-b704-eeb506c142be",
        "storage_key": "property/6767906449166442/019f060b-e723-753b-b704-eeb506c142be.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://schools.sunrisepreschools.com/az/tolleson/350-n-96th-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=9351961405636491143&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sunrise-preschools",
      "poi_latitude": "33.4514155",
      "poi_longitude": "-112.266569",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 623-907-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02ca-c32e-7604-b39a-d7c24cfa137e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ca-c32e-7604-b39a-d7c24cfa137e",
        "storage_key": "property/6767906449166442/019d02ca-c32e-7604-b39a-d7c24cfa137e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRULdoC0-K4cRhzcggFnXyIE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    }
  ],
  "office_hours": [
    {
      "id": "ec_d5d183e3ed712dbb4962de0d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_11eb4c00aefe6d7502c11f35",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b27099efbd9272719734259b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fc5cbe36c72189b63b085a34",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c793c00b62e008e59f1152e8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d3e2545ba2a5a1a501ebbb99",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_a5a44873-80af-49d8-9df9-95f63456875a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "rating": "5.0",
      "name": "Cynthia M",
      "text": "Recently moved out have been here for about a year and I had a wonderful experience! The office staff is very friendly and are ready to help out in any way possible. Yanika was great and was always open to talk about anything I had to bring to her attention. And the assistant manager Grecia was just as great! She always was ready to help and would take her time to do her best to help me during my time here! And Georgina I didn’t tour with her but she’s been such a great energy always smiling and will always tell you good morning and ask about your day! The maintenance team is also awesome very friendly and gets the job done in a timely and efficient manner. If I hadn’t been offered my promotion and forced to relocate I would have definitely renewed. Thank you for the wonderful experience Parc Lofts!!",
      "date": "2025-09-20",
      "title": ""
    },
    {
      "id": "custom_75a073e1-d8aa-4b04-a504-a3fc29b1e979",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "rating": "5.0",
      "name": "Gina P",
      "text": "After almost one year of being here, I’m thinking of renewing. Living here has been a great experience The office staff is always willing to help with anything. The manager is super professional and is quick to solve any issues. This place has grew upon me. It’s very peaceful. The area is always clean. They keep up with The property.I would definitely Recommend this place says someone who has been here almost a year. Thank you, Parclofts for all the hard work and for keeping your tenants happy. The manager that’s running this place you’re doing amazing.",
      "date": "2025-05-01",
      "title": ""
    },
    {
      "id": "custom_3aaecac3-f186-4501-b547-9043a0bbfd89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "rating": "5.0",
      "name": "Maryn Bulygo",
      "text": "I’ve had a great experience living at Parc Lofts!  The space itself is stylish, comfortable, and feels like home—but what truly sets this place apart is the incredible management team, Yanika in particular, has been consistently helpful, responsive, and genuinely cares about the residents. She goes above and beyond to make sure everything runs smoothly and always handles questions or concerns with kindness and professionalism. It makes such a difference knowing you’re supported by someone who truly takes pride in the community. Highly recommend!",
      "date": "2025-07-19",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_5b07c84c-b7ad-40bd-b7bf-a23e9bd75b33",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02cb-d282-726c-b88c-0937d6aa635e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "A billiards table and dining area in a modern community lounge.",
        "public_id": "019d02cb-d282-726c-b88c-0937d6aa635e",
        "storage_key": "property/6767906449166442/019d02cb-d282-726c-b88c-0937d6aa635e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Social Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=JXqQf8vNJix"
    },
    {
      "id": "custom_7fff1612-a675-48c6-8545-6ba80d84d91d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02cb-d2b1-727e-982b-0c07b50759be.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Gym with weight machines, cardio equipment, and free weights.",
        "public_id": "019d02cb-d2b1-727e-982b-0c07b50759be",
        "storage_key": "property/6767906449166442/019d02cb-d2b1-727e-982b-0c07b50759be.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=iy2ixGPodcB"
    },
    {
      "id": "custom_dd5f7742-afe0-4a90-86e4-bbdf865c275f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02cb-3cba-77ab-9ada-a8daeceee01f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Swimming pool and lounge chairs with apartment buildings in the background.",
        "public_id": "019d02cb-3cba-77ab-9ada-a8daeceee01f",
        "storage_key": "property/6767906449166442/019d02cb-3cba-77ab-9ada-a8daeceee01f.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Community Tour | Poolside Oasis",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=qnogCuipUNE"
    },
    {
      "id": "custom_5ea29a4d-fa33-4686-a36d-b8dd9a841d4f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02cb-42d5-75da-ae70-ea0527279975.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and white countertops.",
        "public_id": "019d02cb-42d5-75da-ae70-ea0527279975",
        "storage_key": "property/6767906449166442/019d02cb-42d5-75da-ae70-ea0527279975.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "Apartment Tour | 1 BR, 1 BA | 741 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=EJmDZ2Hga5r"
    },
    {
      "id": "custom_b5c8cbdd-705c-4cdf-9bca-4af7b0d6c3db",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02cb-468a-7018-850f-e5e94a9a3607.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with dark cabinetry, stainless steel appliances, and an island overlooking a living area.",
        "public_id": "019d02cb-468a-7018-850f-e5e94a9a3607",
        "storage_key": "property/6767906449166442/019d02cb-468a-7018-850f-e5e94a9a3607.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 1076 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=D1uposGbSWg"
    },
    {
      "id": "custom_3042bffe-0ea3-475c-8f81-cd463952e1a5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166442/019d02cb-4b0f-71ee-8f36-8517973228a7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and island with sink.",
        "public_id": "019d02cb-4b0f-71ee-8f36-8517973228a7",
        "storage_key": "property/6767906449166442/019d02cb-4b0f-71ee-8f36-8517973228a7.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "Apartment Tour | 3 BR, 3 BA | 1310 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=B19Q2jgKoJE"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199dfe2-2851-70a9-8614-08cc15348e36",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-parc-lofts-auto",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-in-unit-laundry-tolleson-az",
      "search_query": "luxury apartments with in-unit laundry Tolleson AZ",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover luxury living in Tolleson, AZ with in-unit laundry. Parc Lofts offers modern amenities in a dynamic community.",
      "page_copy": "If you're seeking luxury apartments with in-unit laundry in Tolleson, AZ, Parc Lofts is the ideal choice. Nestled in the vibrant city of Tolleson, our community is designed to provide both convenience and comfort. Our residents enjoy the ease of in-unit laundry alongside a host of other upscale amenities such as central air conditioning, private balconies or patios, and a state-of-the-art 24-hour fitness center on-site.\n\nLiving at Parc Lofts means more than just having a stylish home; it's about experiencing a community that values your lifestyle needs. With our gated community, you can relax knowing privacy and security are prioritized. Plus, with window coverings in every apartment, you can adjust your space exactly as you like. Come explore modern comforts and more in one of the finest luxury apartment communities in Tolleson, AZ.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with In-Unit Laundry | Tolleson AZ",
      "seo_description": "Explore luxury living at Parc Lofts with in-unit laundry and modern amenities in Tolleson, AZ.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-dog-park-near-85353",
      "search_query": "pet friendly apartments with dog park near 85353",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments with Dog Park",
      "h2_subtitle": "Discover pet friendly apartments near 85353 featuring a convenient dog park. Parc Lofts is perfect for you and your furry friend.",
      "page_copy": "Finding pet friendly apartments with a dog park near 85353 is a breeze at Parc Lofts. Located in the heart of Tolleson, AZ, our community warmly welcomes both you and your pets. The expansive dog park offers a perfect venue for your furry friend to roam and play, ensuring they enjoy their time just as much as you do. Our pet-friendly policies are designed to make living with your pet a seamless experience, with plenty of open and green spaces dedicated to their enjoyment.\n\nThe benefits of living at Parc Lofts extend beyond just pet accommodation. You'll have access to premium amenities, including central air conditioning to keep you cool, window coverings for added privacy, and private balconies or patios for a breath of fresh air. Our gated community ensures security and peace of mind, and the 24-hour fitness center provides on-demand access to maintain your active lifestyle. Experience a welcoming environment for both you and your pet at Parc Lofts.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apts with Dog Park | Near 85353",
      "seo_description": "Live at Parc Lofts near 85353, where you and your pet can enjoy a dog park and pet-friendly amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "generator",
      "page_item_url": "private-balconies-air-conditioning-apartments-tolleson",
      "search_query": "apartments with private balconies and air conditioning Tolleson",
      "category": "Amenity",
      "h1_title": "Apartments with Private Balconies in Tolleson",
      "h2_subtitle": "Enjoy apartments with private balconies and air conditioning in Tolleson. Discover the comfort at Parc Lofts.",
      "page_copy": "Parc Lofts offers the perfect blend of comfort and style in Tolleson, AZ, featuring apartments with private balconies and air conditioning. Our private balconies and patios provide a serene escape where you can unwind and relish the views. Whether you're sipping your morning coffee or enjoying an evening breeze, these outdoor spaces are designed to enhance your daily living experience.\n\nInside, our apartments are equipped with central air conditioning, ensuring you remain comfortable no matter the season. Additional top-tier amenities include window coverings, a modern 24-hour fitness center, and the security of a gated community. At Parc Lofts, not only do you enjoy sophisticated living indoors, but also a thriving community atmosphere just outside your door. Come see why Parc Lofts is the prime choice for those seeking comfort with convenience in Tolleson.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Balconies & Air Conditioning | Tolleson",
      "seo_description": "Parc Lofts in Tolleson offers apartments with private balconies and central air conditioning for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "generator",
      "page_item_url": "covered-parking-apartments-maricopa-county",
      "search_query": "covered parking apartments Maricopa County",
      "category": "Amenity",
      "h1_title": "Covered Parking Apartments in Maricopa County",
      "h2_subtitle": "Explore apartments with covered parking in Maricopa County. Experience the comfort and convenience at Parc Lofts.",
      "page_copy": "Searching for covered parking apartments in Maricopa County? Look no further than Parc Lofts, where convenience meets modern living in Tolleson, AZ. Our apartments ensure that your vehicle is well-protected from the elements, allowing you peace of mind while also offering easy access to everything you need.\n\nIn addition to covered parking, Parc Lofts provides a host of upscale amenities aimed at enhancing your lifestyle. Enjoy central air conditioning, ensuring a comfortable home environment year-round, and step onto private balconies or patios for a moment of relaxation. With the advantage of window coverings, privacy is essential in this gated community. With a 24-hour fitness center, staying active right within the community has never been this convenient. Join us at Parc Lofts for an elevated apartment living experience in Maricopa County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Covered Parking Apartments | Maricopa County",
      "seo_description": "Discover Parc Lofts in Maricopa County, offering covered parking apartments with modern amenities for comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "generator",
      "page_item_url": "tolleson-apartments-dishwashers-quartz-countertops",
      "search_query": "Tolleson apartments with dishwashers and sleek quartz countertops",
      "category": "Amenity",
      "h1_title": "Tolleson Apartments with Modern Kitchens",
      "h2_subtitle": "Find Tolleson apartments featuring dishwashers and sleek quartz countertops at Parc Lofts. Modern living awaits you.",
      "page_copy": "Experience the height of modern living at Parc Lofts, offering Tolleson apartments equipped with dishwashers and sleek quartz countertops. These stylish and functional kitchens are designed to make meal preparation and cleanup a breeze, combining convenience with contemporary aesthetics.\n\nEvery detail of our apartments is crafted with comfort in mind. In addition to top-notch kitchen amenities, residents enjoy central air conditioning, private balconies or patios, and window coverings for added privacy. The community boasts a variety of lifestyle-enhancing features, including a 24-hour fitness center and the security of a gated community. Located in the heart of Tolleson, Parc Lofts is your gateway to luxurious apartment living with cutting-edge kitchen designs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Tolleson Apts: Dishwashers & Quartz Countertops",
      "seo_description": "Parc Lofts in Tolleson offers modern apartments with dishwashers and sleek quartz countertops for a contemporary living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-tolleson",
      "search_query": "one bedroom apartments Tolleson",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Tolleson",
      "h2_subtitle": "Discover spacious one bedroom apartments in Tolleson at Parc Lofts. Enjoy comfort and convenience in every corner.",
      "page_copy": "Parc Lofts offers inviting one bedroom apartments in Tolleson, perfect for those seeking a comfortable and stylish home. Our thoughtfully designed floor plans maximize space and light, providing a warm and welcoming atmosphere. Each apartment is equipped with central air conditioning and private balconies or patios, ensuring you enjoy both indoor comfort and outdoor relaxation.\n\nLocated in a gated community, Parc Lofts offers numerous amenities, including a 24-hour fitness center and modern window coverings, enhancing your living experience. Whether you’re a professional working nearby or simply in search of the perfect one bedroom sanctuary, Parc Lofts provides a community-oriented lifestyle with easy access to local conveniences. Come explore the blend of tranquility and modern living awaiting you at Parc Lofts.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments | Tolleson Living",
      "seo_description": "Explore Parc Lofts' one bedroom apartments in Tolleson, offering comfort with central air conditioning and private balconies.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-near-85353",
      "search_query": "2 bedroom apartments near zip 85353",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near Zip 85353",
      "h2_subtitle": "Explore spacious 2 bedroom apartments near zip code 85353 at Parc Lofts. Comfort meets style in every unit.",
      "page_copy": "If you're searching for 2 bedroom apartments near zip code 85353, Parc Lofts in Tolleson is the perfect place to call home. Our beautifully crafted apartments are designed to provide ample space and modern flair, ensuring a relaxing and convenient living environment for all our residents.\n\nLocated in a gated community, Parc Lofts offers more than just spacious living spaces. Enjoy amenities like central air conditioning, private balconies or patios, and window coverings, all designed to enhance your day-to-day life. With a 24-hour fitness center on-site, staying active has never been easier. Ideally located in Maricopa County, Parc Lofts presents a harmonious blend of comfort and accessibility, making it an ideal choice for those seeking a vibrant community near 85353.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments | Near Zip 85353",
      "seo_description": "Find 2 bedroom apartments near 85353 at Parc Lofts, Tolleson. Enjoy spacious living with modern amenities in a gated community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-maricopa-county",
      "search_query": "three bedroom apartments Maricopa County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Maricopa County",
      "h2_subtitle": "Discover three bedroom apartments in Maricopa County at Parc Lofts. Ample space and modern amenities await.",
      "page_copy": "Parc Lofts is proud to offer spacious three bedroom apartments in Maricopa County, designed for those who value comfort and modern living. Each unit is thoughtfully laid out with generous living spaces, providing the perfect setting for family life or shared living arrangements. Our apartments are equipped with central air conditioning and feature elegant private balconies or patios, offering additional space to unwind.\n\nLocated within a secure gated community, Parc Lofts goes beyond with amenities like a 24-hour fitness center and quality window coverings, ensuring a lifestyle that is both active and cozy. Situated in the vibrant area of Tolleson, our community offers both convenience and serenity. Choose Parc Lofts to experience living in spacious three bedroom residences with easy access to all that Maricopa County has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments | Maricopa County",
      "seo_description": "Find spacious three bedroom apartments in Maricopa County at Parc Lofts, featuring central air and private balconies in a gated community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "generator",
      "page_item_url": "apartments-near-estrella-mountain-community-college",
      "search_query": "apartments near Estrella Mountain Community College Tolleson",
      "category": "School",
      "h1_title": "Apartments Near Estrella Mountain Community College",
      "h2_subtitle": "Find stylish apartments near Estrella Mountain Community College in Tolleson, offering comfort and modern amenities for students and professionals.",
      "page_copy": "Looking for convenient apartments near Estrella Mountain Community College in Tolleson? Parc Lofts offers the perfect home base for students and professionals alike. Our apartments boast a blend of comfort and style, with modern amenities such as central air conditioning and private balconies or patios providing a delightful living experience.\n\nSituated in a secured gated community, Parc Lofts provides residents with exceptional facilities, including a 24-hour fitness center and stylish window coverings. Our prime location ensures easy access to Estrella Mountain Community College, making it simple to balance academic life with relaxation and recreation. Choose Parc Lofts for a hassle-free and enjoyable living experience near your educational pursuits.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments | Near Estrella Mountain College Tolleson",
      "seo_description": "Discover apartments near Estrella Mountain Community College at Parc Lofts, featuring modern amenities in Tolleson's gated community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "generator",
      "page_item_url": "apartments-near-abrazo-west-campus-maricopa",
      "search_query": "apartments near abrazo west campus maricopa county",
      "category": "Hospital",
      "h1_title": "Apartments Near Abrazo West Campus, Maricopa",
      "h2_subtitle": "Discover modern apartments near Abrazo West Campus in Maricopa County. Enjoy convenience and comfort at Parc Lofts.",
      "page_copy": "Parc Lofts in Tolleson offers beautiful apartments conveniently located near Abrazo West Campus in Maricopa County. Our community provides an ideal living environment for healthcare professionals and students, featuring spacious units with modern amenities such as central air conditioning and private balconies or patios. \n\nAs a resident of Parc Lofts, you'll enjoy the benefits of living in a secure, gated community with access to a 24-hour fitness center and ample parking. Window coverings add a touch of elegance while ensuring privacy. Our prime location near Abrazo West Campus makes Parc Lofts the perfect choice for those seeking a well-balanced lifestyle, combining convenience with luxury and tranquility.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments | Near Abrazo West Campus, Maricopa",
      "seo_description": "Find modern apartments near Abrazo West Campus at Parc Lofts in Maricopa County. Enjoy luxury and comfort in a gated community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "generator",
      "page_item_url": "apartments-close-banner-estrella-medical-center",
      "search_query": "apartments close to banner estrella medical center tolleson az",
      "category": "Hospital",
      "h1_title": "Apartments Close to Banner Estrella Medical Center",
      "h2_subtitle": "Explore apartments close to Banner Estrella Medical Center in Tolleson, AZ. Enjoy a blend of convenience and modern living at Parc Lofts.",
      "page_copy": "Parc Lofts offers proximity and convenience with its location close to Banner Estrella Medical Center in Tolleson, AZ. Perfect for healthcare professionals and their families, our apartments provide top-notch comfort with features like central air conditioning and private balconies or patios that help create a perfect home environment.\n\nThe community includes a secure gated space, a 24-hour fitness center, and modern window coverings that enhance both style and functionality. With Parc Lofts, you benefit from a peaceful setting while staying close to your workplace at Banner Estrella Medical Center. Discover a seamless blend of luxury and practicality at Parc Lofts, designed for those who prioritize both career and comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Banner Estrella Medical Center",
      "seo_description": "Find apartments close to Banner Estrella Medical Center in Tolleson, AZ at Parc Lofts, offering convenience and modern amenities in a gated community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "generator",
      "page_item_url": "apartments-near-friendship-park-tolleson",
      "search_query": "apartments near Friendship Park Tolleson",
      "category": "Park",
      "h1_title": "Apartments Near Friendship Park in Tolleson",
      "h2_subtitle": "Discover apartments near Friendship Park in Tolleson. Enjoy a vibrant community with modern amenities at Parc Lofts.",
      "page_copy": "Parc Lofts stands as an appealing choice for those seeking apartments near Friendship Park in Tolleson. Our location offers easy access to the recreational opportunities at this beloved local park, ideal for picnics, sports, and leisurely strolls. At Parc Lofts, residents are welcomed into a community that seamlessly combines comfort and style.\n\nWith spacious units featuring private balconies or patios and central air conditioning, Parc Lofts ensures a pleasant living environment. The gated community boasts a 24-hour fitness center and stylish window coverings, providing both security and modern convenience. Experience the best of Tolleson living, just a stone’s throw from Friendship Park's lush, green spaces.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Friendship Park Tolleson",
      "seo_description": "Explore Parc Lofts near Friendship Park in Tolleson. Enjoy stylish living with modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "generator",
      "page_item_url": "apartments-close-glendale-heroes-regional-park",
      "search_query": "apartments close to Glendale Heroes Regional Park AZ",
      "category": "Park",
      "h1_title": "Apartments Close to Glendale Heroes Regional Park",
      "h2_subtitle": "Explore apartments close to Glendale Heroes Regional Park, AZ. Parc Lofts offers modern living with easy park access.",
      "page_copy": "Parc Lofts is ideally situated for those seeking apartments close to Glendale Heroes Regional Park, AZ. Enjoy the park's abundant recreational offerings, from sports courts to scenic trails, just a short drive from our community. At Parc Lofts, we strive to provide a comfortable and welcoming atmosphere, perfect for active lifestyles.\n\nResidents benefit from spacious living spaces that include private balconies or patios and central air conditioning to ensure year-round comfort. The community features a secure, gated environment with a 24-hour fitness center and stylish window coverings, catering to both convenience and modern aesthetics. Choose Parc Lofts for a harmonious balance of relaxation and recreation near Glendale Heroes Regional Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Glendale Heroes Regional Park",
      "seo_description": "Parc Lofts offers apartments close to Glendale Heroes Regional Park, AZ. Enjoy comfort and modern living near parks and recreational sites.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166442",
      "source": "generator",
      "page_item_url": "rentals-near-alamar-park-maricopa-county",
      "search_query": "rentals near Alamar Park Maricopa County",
      "category": "Park",
      "h1_title": "Rentals Near Alamar Park, Maricopa County",
      "h2_subtitle": "Find rentals near Alamar Park in Maricopa County. Discover the comfortable living options at Parc Lofts.",
      "page_copy": "Looking for rentals near Alamar Park in Maricopa County? Parc Lofts offers an ideal location, just moments away from the natural beauty and recreational amenities of Alamar Park. Whether you're an outdoor enthusiast or someone who enjoys serene park views, our community combines convenience with a modern lifestyle.\n\nAt Parc Lofts, you'll find spacious rentals equipped with private balconies or patios, central air conditioning, and stylish window coverings. Our gated community ensures a secure living environment and includes a 24-hour fitness center to meet all your wellness needs. Choose Parc Lofts for seamless access to Alamar Park while enjoying a robust living atmosphere.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Alamar Park, Maricopa County",
      "seo_description": "Explore Parc Lofts' rentals near Alamar Park, Maricopa County. Enjoy modern amenities and convenient park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5314"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18104425004"
    },
    {
      "ID": "custom_lea_chatbot",
      "type": "STRING",
      "value": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=5835247085dee9e01496b3731bf53bf8e9d869a4a4181d40e05144b91d682e1710593002dd5f3868e529688b1e78ef08\"></script>"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-K27KR8G8"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "905PLO"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40261522739"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "BR573712000"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Parc Lofts/scheduletourwidget/7EvwqxKoEYKBUotTKp/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImFodTlia3FLMDNwUThUSlUzRU1YNFE9PSIsInZhbHVlIjoiSXgrYVRJM1dKa1NHbDNiVXVPWUZkQT09IiwibWFjIjoiZDFlYzYzNThjZGQwNjIyNWVlZGZiODFlZmFjYzMyYmE1ZDQ3OTNkYjg2Mzc0ZmY1ZjNlNTcxNzYwODA1MGIzMyJ9"
    }
  ],
  "custom_qb_id": "5314",
  "custom_repli_id": "18104425004",
  "custom_lea_chatbot": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=5835247085dee9e01496b3731bf53bf8e9d869a4a4181d40e05144b91d682e1710593002dd5f3868e529688b1e78ef08\"></script>",
  "custom_google_gtm_id": "GTM-K27KR8G8",
  "custom_rollout_phase": "Milburn",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_aim_property_code": "905PLO",
  "custom_hubspot_company_id": "40261522739",
  "custom_broker_license_number": "BR573712000",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Parc Lofts/scheduletourwidget/7EvwqxKoEYKBUotTKp/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImFodTlia3FLMDNwUThUSlUzRU1YNFE9PSIsInZhbHVlIjoiSXgrYVRJM1dKa1NHbDNiVXVPWUZkQT09IiwibWFjIjoiZDFlYzYzNThjZGQwNjIyNWVlZGZiODFlZmFjYzMyYmE1ZDQ3OTNkYjg2Mzc0ZmY1ZjNlNTcxNzYwODA1MGIzMyJ9",
  "custom_audioeye_site_id": "182e41f8-0cd5-4616-bf15-035e55accb2a",
  "custom_audioeye_site_hash": "37611305e8f0b97d98a41111019900b9"
};

export const generatedAt = '2026-08-21T22:01:04.709Z';
